(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kv-bedding-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
  function initKvBundle(root) {
    if (!root || root.dataset.kvBundleInit === 'true') return;
    root.dataset.kvBundleInit = 'true';

    const formId = root.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const useBundleProducts = root.dataset.useBundleProducts === 'true';
    const variantsEl = root.querySelector('[data-kv-bundle-variants]');
    const setProductsEl = root.querySelector('[data-kv-bundle-set-products]');
    const atcBtn = root.querySelector('[data-kv-bundle-atc]');
    const atcPricesWrap = root.querySelector('.kv-bundle__atc-prices');
    const atcPriceEl = root.querySelector('[data-kv-atc-price]');
    const atcCompareEl = root.querySelector('[data-kv-atc-compare]');
    const atcLabelEl = root.querySelector('[data-kv-atc-label]');
    const atcMessageEl = root.querySelector('[data-kv-atc-message]');

    let repairingBundleAtcText = false;

    const atcDefaultLabel = (atcLabelEl && atcLabelEl.textContent.trim()) || root.dataset.atcLabel || 'Add to cart';
    const atcSoldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const productId = root.dataset.productId;

    function getIgRawPrice(igPriceApi, variantId, productIdValue) {
      if (!igPriceApi) return null;

      let raw = null;
      if (
        productIdValue &&
        typeof igPriceApi.getPriceByProductIdAndVariantId === 'function'
      ) {
        raw = igPriceApi.getPriceByProductIdAndVariantId(String(productIdValue), String(variantId));
      }
      if (
        (raw == null || raw === '') &&
        typeof igPriceApi.getPriceByVariantId === 'function'
      ) {
        raw = igPriceApi.getPriceByVariantId(String(variantId));
      }
      return raw;
    }

    function getIgRawComparePrice(igPriceApi, variantId, productIdValue) {
      if (!igPriceApi) return null;

      let raw = null;
      if (
        productIdValue &&
        typeof igPriceApi.getComparePriceByProductIdAndVariantId === 'function'
      ) {
        raw = igPriceApi.getComparePriceByProductIdAndVariantId(String(productIdValue), String(variantId));
      }
      if (
        (raw == null || raw === '') &&
        typeof igPriceApi.getComparePriceByVariantId === 'function'
      ) {
        raw = igPriceApi.getComparePriceByVariantId(String(variantId));
      }
      return raw;
    }

    function parseIgMoneyToCents(raw, fallbackCents) {
      if (raw == null || raw === '') return fallbackCents;
      if (typeof raw === 'number' && Number.isFinite(raw)) {
        return Number.isInteger(raw) && raw >= 100 ? raw : Math.round(raw * 100);
      }

      const normalized = String(raw).trim();
      if (!normalized) return fallbackCents;

      const digits = normalized.replace(/[^0-9.]/g, '');
      if (!digits) return fallbackCents;

      const dollars = parseFloat(digits);
      return Number.isFinite(dollars) ? Math.round(dollars * 100) : fallbackCents;
    }

    function igPriceCents(variantId, fallback, productIdValue) {
      const igPriceApi = window.igData && window.igData.price;
      return parseIgMoneyToCents(getIgRawPrice(igPriceApi, variantId, productIdValue), fallback);
    }

    function igCompareCents(variantId, fallback, productIdValue) {
      const igPriceApi = window.igData && window.igData.price;
      return parseIgMoneyToCents(getIgRawComparePrice(igPriceApi, variantId, productIdValue), fallback);
    }

    function applyIgPriceAttributes(el, variantId, productIdValue, unitPriceCents, multiplier, isAggregate, variantIds) {
      if (!el) return;

      el.setAttribute('data-price-multiplier', String(multiplier || 1));

      if (isAggregate) {
        el.setAttribute('data-kv-price-cents', String(unitPriceCents * (multiplier || 1)));
        el.removeAttribute('data-ig-aggregate');
        el.removeAttribute('data-variant-id');
        el.removeAttribute('data-product-id');
        el.removeAttribute('data-price');
        el.removeAttribute('data-kv-bundle-variant-ids');
        return;
      }

      el.removeAttribute('data-ig-aggregate');
      el.removeAttribute('data-kv-bundle-variant-ids');
      el.removeAttribute('data-kv-price-cents');
      el.setAttribute('data-price', String(unitPriceCents));
      if (variantId) el.setAttribute('data-variant-id', String(variantId));
      if (productIdValue) el.setAttribute('data-product-id', String(productIdValue));
    }

    function getSingleVariantDisplayPricing(variant, productIdValue) {
      if (!variant) return null;

      const unitPrice = igPriceCents(variant.id, variant.price, productIdValue);
      const unitCompare = igCompareCents(variant.id, variant.compare_at_price || 0, productIdValue);

      return {
        id: variant.id,
        productId: productIdValue,
        available: variant.available,
        price: unitPrice,
        compare_at_price: unitCompare > unitPrice ? unitCompare : 0,
        isAggregate: false
      };
    }

    function updateBundlePairIgUnits(pricingEl) {
      if (!pricingEl) return;

      pricingEl.querySelectorAll('[data-kv-bundle-ig-unit]').forEach(function (unit) {
        const productIdValue = unit.getAttribute('data-product-id');
        const variant = resolveBundleProductVariant(productIdValue);
        if (!variant) return;

        const unitPrice = igPriceCents(variant.id, variant.price, variant.productId);
        const unitCompare = igCompareCents(variant.id, variant.compare_at_price || 0, variant.productId);

        unit.setAttribute('data-product-id', String(variant.productId));
        unit.setAttribute('data-variant-id', String(variant.id));
        unit.setAttribute('data-price', String(unitPrice));
        unit.setAttribute('data-compare-price', String(unitCompare > unitPrice ? unitCompare : unitPrice));
        unit.textContent = formatMoney(unitPrice);
      });
    }

    function getBundlePairPricing(productIdsOrPricingEl) {
      let pricingEl = null;
      let productIds = '';

      if (productIdsOrPricingEl && productIdsOrPricingEl.getAttribute) {
        pricingEl = productIdsOrPricingEl;
        productIds = pricingEl.getAttribute('data-product-ids') || '';
      } else {
        productIds = productIdsOrPricingEl || getBundlePairProductIds(getSelectedSetInput());
        pricingEl = getBundleSetCardPricingEl();
      }

      const ids = parseProductIds(productIds);
      if (!ids.length) return null;

      if (pricingEl) {
        updateBundlePairIgUnits(pricingEl);
      }

      const units = pricingEl ? pricingEl.querySelectorAll('[data-kv-bundle-ig-unit]') : [];
      const pair = ids.map(resolveBundleProductVariant).filter(Boolean);

      if (!pair.length) return null;

      let price = 0;
      let compareAt = 0;

      if (units.length) {
        units.forEach(function (unit) {
          const productIdValue = unit.getAttribute('data-product-id');
          const variant = resolveBundleProductVariant(productIdValue);
          if (!variant) return;

          const fallback = Number(variant.price) || 0;
          const fallbackCompare = Number(variant.compare_at_price) || 0;
          const igReady = !!(window.igData && window.igData.price);
          const unitPrice = igReady
            ? igPriceCents(variant.id, fallback, variant.productId)
            : Number(unit.getAttribute('data-price')) || fallback;
          const unitCompareRaw = igReady
            ? igCompareCents(variant.id, fallbackCompare, variant.productId)
            : Number(unit.getAttribute('data-compare-price')) || fallbackCompare;
          const unitCompare = unitCompareRaw > unitPrice ? unitCompareRaw : unitPrice;

          price += unitPrice;
          compareAt += unitCompare;
        });
      } else {
        pair.forEach(function (variant) {
          const unitPrice = igPriceCents(variant.id, variant.price, variant.productId);
          const unitCompare = igCompareCents(variant.id, variant.compare_at_price || 0, variant.productId);
          price += unitPrice;
          compareAt += unitCompare > unitPrice ? unitCompare : unitPrice;
        });
      }

      return {
        id: pair[0].id,
        productId: pair[0].productId,
        variantIds: pair.map(function (variant) {
          return variant.id;
        }),
        productIds: pair.map(function (variant) {
          return variant.productId;
        }),
        available: pair.every(function (variant) {
          return variant.available;
        }),
        price: price,
        compare_at_price: compareAt > price ? compareAt : 0,
        isAggregate: ids.length > 1
      };
    }

    function getBundlePairDisplayPricing(productIds) {
      const pricingEl = getBundleSetCardPricingEl();
      if (pricingEl) {
        const elIds = pricingEl.getAttribute('data-product-ids') || '';
        if (!productIds || String(productIds) === String(elIds)) {
          return getBundlePairPricing(pricingEl);
        }
      }
      return getBundlePairPricing(productIds || '');
    }

    function getSetType(setInput) {
      if (!setInput) return '';
      return setInput.getAttribute('data-set-type') || '';
    }

    function isBundleSetSelected() {
      return useBundleProducts && getSetType(getSelectedSetInput()) === 'bundle';
    }

    function getBundleSetCardPricingEl() {
      return root.querySelector('[data-kv-set-pricing][data-set-bundle]');
    }

    function setBundleAtcMoneyDisplay(el, cents) {
      if (!el || !Number.isFinite(cents) || cents <= 0) return;

      repairingBundleAtcText = true;
      el.textContent = formatMoney(cents);
      el.setAttribute('data-kv-bundle-aggregate', 'true');
      el.setAttribute('data-kv-price-cents', String(cents));
      el.removeAttribute('data-ig-aggregate');
      el.removeAttribute('data-variant-id');
      el.removeAttribute('data-product-id');
      el.removeAttribute('data-price');
      el.removeAttribute('data-price-multiplier');
      el.removeAttribute('data-kv-bundle-variant-ids');
      el.hidden = false;
      el.removeAttribute('aria-hidden');
      repairingBundleAtcText = false;
    }

    function clearBundleAtcMoneyDisplay(el) {
      if (!el) return;

      repairingBundleAtcText = true;
      el.textContent = '';
      el.removeAttribute('data-kv-bundle-aggregate');
      el.removeAttribute('data-kv-price-cents');
      el.removeAttribute('data-ig-aggregate');
      el.removeAttribute('data-variant-id');
      el.removeAttribute('data-product-id');
      el.removeAttribute('data-price');
      el.removeAttribute('data-price-multiplier');
      el.removeAttribute('data-kv-bundle-variant-ids');
      el.hidden = true;
      repairingBundleAtcText = false;
    }

    function syncBundleAtcDisplayFromPricing(pricing) {
      if (!atcPriceEl || !pricing) return false;

      setBundleAtcMoneyDisplay(atcPriceEl, pricing.price);

      if (atcCompareEl) {
        if (pricing.compare_at_price > pricing.price) {
          setBundleAtcMoneyDisplay(atcCompareEl, pricing.compare_at_price);
        } else {
          clearBundleAtcMoneyDisplay(atcCompareEl);
        }
      }

      if (atcPricesWrap) {
        atcPricesWrap.hidden = !pricing.price;
      }

      return true;
    }

    function repairBundleAtcTextFromCents() {
      if (!isBundleSetSelected() || !atcPriceEl) return;

      const priceCents = Number(atcPriceEl.getAttribute('data-kv-price-cents')) || 0;
      if (priceCents) {
        const expectedPrice = formatMoney(priceCents);
        if (atcPriceEl.textContent.trim() !== expectedPrice) {
          setBundleAtcMoneyDisplay(atcPriceEl, priceCents);
        }
      }

      if (!atcCompareEl) return;

      const compareCents = Number(atcCompareEl.getAttribute('data-kv-price-cents')) || 0;
      if (compareCents) {
        const expectedCompare = formatMoney(compareCents);
        if (atcCompareEl.textContent.trim() !== expectedCompare) {
          setBundleAtcMoneyDisplay(atcCompareEl, compareCents);
        }
      } else if (atcCompareEl.textContent.trim()) {
        clearBundleAtcMoneyDisplay(atcCompareEl);
      }
    }

    function applyBundlePairAtcPricing(pricing) {
      if (!atcPriceEl || !pricing) return false;

      if (atcBtn) {
        atcBtn.disabled = !pricing.available;
        setAtcLabel(!pricing.available);
        atcBtn.removeAttribute('data-kv-bundle-variant-ids');
      }

      if (atcPricesWrap) {
        atcPricesWrap.hidden = false;
      }

      syncBundleAtcDisplayFromPricing(pricing);

      window.requestAnimationFrame(function () {
        if (!root.isConnected || !isBundleSetSelected()) return;
        repairBundleAtcTextFromCents();
      });

      return true;
    }

    function updateBundlePairUi() {
      const pricingEl = getBundleSetCardPricingEl();
      if (!pricingEl) return null;

      const pricing = getBundlePairPricing(pricingEl);
      if (!pricing) return null;

      updatePricingEl(pricingEl, pricing);

      if (isBundleSetSelected()) {
        applyBundlePairAtcPricing(pricing);
      }

      return pricing;
    }

    function applyBundleAtcPricing(pricing) {
      applyBundlePairAtcPricing(pricing);
    }

    function getSetPriceEl(pricingEl) {
      if (!pricingEl) return null;
      return (
        pricingEl.querySelector('[data-kv-bundle-price]') ||
        pricingEl.querySelector('[data-price]')
      );
    }

    function getSetCompareEl(pricingEl) {
      if (!pricingEl) return null;
      return (
        pricingEl.querySelector('[data-kv-bundle-compare]') ||
        pricingEl.querySelector('[data-compare]')
      );
    }

    function getSelectedSetPricingEl() {
      const setInput = getSelectedSetInput();
      if (!setInput || !setInput.id) return null;

      const label = root.querySelector('label[for="' + setInput.id + '"]');
      return label ? label.querySelector('[data-kv-set-pricing]') : null;
    }

    function getDisplayPricingFromSetCard(pricingEl, fallbackPricing) {
      if (!pricingEl) return fallbackPricing;

      const priceEl = getSetPriceEl(pricingEl);
      if (!priceEl) return fallbackPricing;

      const compareEl = getSetCompareEl(pricingEl);
      const priceCents =
        Number(priceEl.getAttribute('data-kv-price-cents')) ||
        Number(priceEl.getAttribute('data-price')) ||
        parseIgMoneyToCents(priceEl.textContent, 0);

      if (!priceCents) return fallbackPricing;

      let compareCents = 0;
      if (compareEl && !compareEl.hidden && compareEl.textContent.trim()) {
        compareCents =
          Number(compareEl.getAttribute('data-kv-price-cents')) ||
          Number(compareEl.getAttribute('data-price')) ||
          parseIgMoneyToCents(compareEl.textContent, 0);
      }

      const isAggregate = pricingEl.hasAttribute('data-set-bundle');

      return {
        id: fallbackPricing ? fallbackPricing.id : null,
        productId: fallbackPricing ? fallbackPricing.productId : null,
        variantIds: fallbackPricing ? fallbackPricing.variantIds : null,
        available: fallbackPricing ? fallbackPricing.available : true,
        price: priceCents,
        compare_at_price: compareCents > priceCents ? compareCents : 0,
        isAggregate: isAggregate || !!(fallbackPricing && fallbackPricing.isAggregate)
      };
    }

    function applyAtcDisplayPricing(pricingEl, fallbackPricing) {
      if (!atcPriceEl || !fallbackPricing) return;

      const cardPriceEl = pricingEl ? getSetPriceEl(pricingEl) : null;
      const cardCompareEl = pricingEl ? getSetCompareEl(pricingEl) : null;
      const pricing = getDisplayPricingFromSetCard(pricingEl, fallbackPricing);

      if (!pricing) return;

      if (pricing.isAggregate && cardPriceEl) {
        if (isBundleSetSelected()) {
          updateBundlePairUi();
          return;
        }

        syncBundleAtcDisplayFromPricing(pricing);
        return;
      }

      applyDisplayPricingToElements(atcPriceEl, atcCompareEl, pricing, 1);
    }

    let bundleAtcTailTimers = [];

    function clearBundleAtcTailTimers() {
      bundleAtcTailTimers.forEach(function (timerId) {
        window.clearTimeout(timerId);
      });
      bundleAtcTailTimers = [];
    }

    function ensureBundleAtcPriceAfterIg() {
      if (!isBundleSetSelected()) return;

      clearBundleAtcTailTimers();
      [0, 120, 400, 900, 1500, 3000].forEach(function (delay) {
        const timerId = window.setTimeout(function () {
          if (!root.isConnected || !isBundleSetSelected()) return;
          updateBundlePairUi();
          repairBundleAtcTextFromCents();
        }, delay);
        bundleAtcTailTimers.push(timerId);
      });
    }

    function watchBundleAtcTextFromCents() {
      if (!atcPriceEl || atcPriceEl.getAttribute('data-kv-atc-text-watch') === 'true') return;

      atcPriceEl.setAttribute('data-kv-atc-text-watch', 'true');

      const observer = new MutationObserver(function () {
        if (repairingBundleAtcText || !isBundleSetSelected()) return;
        repairBundleAtcTextFromCents();
      });

      observer.observe(atcPriceEl, {
        childList: true,
        characterData: true,
        subtree: true
      });

      if (atcCompareEl) {
        observer.observe(atcCompareEl, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    function syncAtcPriceFromSelectedSetCard() {
      if (!atcBtn) return;

      const setInput = getSelectedSetInput();
      const setType = getSetType(setInput);

      if (useBundleProducts && setType === 'bundle') {
        updateBundlePairUi();
        ensureBundleAtcPriceAfterIg();
        return;
      }

      const variant = findVariant();

      if (!variant) {
        atcBtn.disabled = true;
        setAtcLabel(true);
        if (atcPriceEl) {
          atcPriceEl.textContent = '';
          atcPriceEl.removeAttribute('data-ig-aggregate');
          atcPriceEl.removeAttribute('data-kv-bundle-aggregate');
          atcPriceEl.removeAttribute('data-price');
          atcPriceEl.removeAttribute('data-variant-id');
          atcPriceEl.removeAttribute('data-product-id');
        }
        if (atcCompareEl) {
          atcCompareEl.textContent = '';
          atcCompareEl.hidden = true;
        }
        return;
      }

      atcBtn.disabled = !variant.available;
      setAtcLabel(!variant.available);
      atcBtn.removeAttribute('data-kv-bundle-variant-ids');

      const fallbackPricing = getCurrentDisplayPricing();
      applyAtcDisplayPricing(getSelectedSetPricingEl(), fallbackPricing);
    }

    function getCurrentDisplayPricing() {
      const setInput = getSelectedSetInput();

      if (useBundleProducts && setInput) {
        const setType = getSetType(setInput);

        if (setType === 'bundle') {
          return getBundlePairDisplayPricing(getBundlePairProductIds(setInput));
        }
        if (setType === 'product') {
          const variant = findBundleProductVariant(setInput.getAttribute('data-product-id'));
          return variant ? getSingleVariantDisplayPricing(variant, variant.productId) : null;
        }
      }

      const variant = findVariant();
      if (!variant) return null;

      if (isBundleSetSelected()) {
        return getBundlePairDisplayPricing(getBundlePairProductIds(getSelectedSetInput()));
      }

      return getSingleVariantDisplayPricing(variant, productId);
    }

    function applyDisplayPricingToElements(priceEl, compareEl, pricing, multiplier) {
      if (!pricing || !priceEl) return;

      const mult = multiplier || 1;
      const totalPrice = pricing.price * mult;
      const totalCompare = pricing.compare_at_price * mult;
      const onSale = pricing.compare_at_price > pricing.price;

      priceEl.textContent = formatMoney(totalPrice);
      applyIgPriceAttributes(
        priceEl,
        pricing.id,
        pricing.productId,
        pricing.price,
        mult,
        pricing.isAggregate,
        pricing.variantIds
      );

      if (!compareEl) return;

      if (onSale) {
        compareEl.textContent = formatMoney(totalCompare);
        applyIgPriceAttributes(
          compareEl,
          pricing.id,
          pricing.productId,
          pricing.compare_at_price,
          mult,
          pricing.isAggregate,
          pricing.variantIds
        );
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    let igRefreshTimer = null;
    let igRefreshDelayTimers = [];
    const igRefreshDelays = [300, 800, 2000, 4000];

    function clearIgRefreshDelayTimers() {
      igRefreshDelayTimers.forEach(function (timerId) {
        window.clearTimeout(timerId);
      });
      igRefreshDelayTimers = [];
    }

    function refreshIgPrices() {
      updateSetCardPrices();
      if (isBundleSetSelected()) {
        updateBundlePairUi();
        ensureBundleAtcPriceAfterIg();
      } else {
        syncAtcPriceFromSelectedSetCard();
      }
    }

    function scheduleIgPriceRefresh() {
      refreshIgPrices();

      if (igRefreshTimer) window.clearTimeout(igRefreshTimer);
      igRefreshTimer = window.setTimeout(function () {
        igRefreshTimer = null;
        refreshIgPrices();
      }, 100);

      clearIgRefreshDelayTimers();
      igRefreshDelays.forEach(function (delay) {
        const timerId = window.setTimeout(function () {
          if (!root.isConnected) return;
          refreshIgPrices();
        }, delay);
        igRefreshDelayTimers.push(timerId);
      });
    }

    window.fmRefreshIgBundleAtcPrices = function () {
      if (!root.isConnected) return;
      refreshIgPrices();
    };

    let variants = [];
    let setProducts = [];

    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    if (setProductsEl) {
      try {
        setProducts = JSON.parse(setProductsEl.textContent).products || [];
      } catch (e) {
        setProducts = [];
      }
    }

    const colorPos = parseInt(root.dataset.colorPosition, 10) || 0;
    const sizePos = parseInt(root.dataset.sizePosition, 10) || 0;
    const setPos = parseInt(root.dataset.setPosition, 10) || 0;

    const colorInputs = root.querySelectorAll('[data-kv-bundle-color]');
    const sizeInputs = root.querySelectorAll('[data-kv-bundle-size]');
    const setInputs = root.querySelectorAll('[data-kv-bundle-set]');

    function getSelected(name) {
      if (name === 'color') {
        const colorInput = root.querySelector('[data-kv-bundle-color]:checked');
        return colorInput ? colorInput.value : null;
      }
      const input = root.querySelector('input[name^="kv-bundle-' + name + '"]:checked');
      return input ? input.value : null;
    }

    const galleryHiddenClass = 'product-gallery__item--hidden';
    const galleryVisibleClass = 'js-product-gallery-slide-visible';

    function setGallerySlideVisible(slide, isVisible) {
      if (isVisible) {
        slide.classList.remove(galleryHiddenClass);
        slide.classList.add(galleryVisibleClass);
      } else {
        slide.classList.add(galleryHiddenClass);
        slide.classList.remove(galleryVisibleClass);
      }
    }

    function filterGallerySlides(slides, colorHandle) {
      slides.forEach(function (slide) {
        const swatchHandle = slide.getAttribute('data-swatch-handle') || '';
        const matches = swatchHandle === 'default' || swatchHandle.indexOf(colorHandle) !== -1;
        setGallerySlideVisible(slide, matches);
      });
    }

    function updateProductGallery() {
      const checkedColor = root.querySelector('[data-kv-bundle-color]:checked');
      if (!checkedColor) return;

      const colorHandle = checkedColor.getAttribute('data-color-value-handle');
      if (!colorHandle) return;

      const productEl = root.closest('.js-product');
      if (!productEl) return;

      const slides = productEl.querySelectorAll('.js-swatch-media');
      if (!slides.length) return;

      const matchCount = Array.from(slides).reduce(function (count, slide) {
        const handle = slide.getAttribute('data-swatch-handle') || '';
        return handle.indexOf(colorHandle) !== -1 ? count + 1 : count;
      }, 0);

      filterGallerySlides(slides, matchCount === 0 ? 'default' : colorHandle);

      const gallery = productEl.querySelector('.js-product-gallery');
      if (gallery && gallery.o && typeof gallery.o.setupSlideshow === 'function') {
        gallery.o.setupSlideshow();
      }
    }

    function getSelectedSetInput() {
      return root.querySelector('[data-kv-bundle-set]:checked');
    }

    function optionValue(variant, position) {
      if (position === 1) return variant.option1;
      if (position === 2) return variant.option2;
      if (position === 3) return variant.option3;
      return null;
    }

    function variantMatchesOptions(variant, color, size) {
      const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      if (color && opts.indexOf(color) === -1) return false;
      if (size && opts.indexOf(size) === -1) return false;
      return true;
    }

    function findBundleProductInSet(productId) {
      return (
        setProducts.find(function (p) {
          return String(p.id) === String(productId);
        }) || null
      );
    }

    function resolveBundleProductVariant(productId) {
      const product = findBundleProductInSet(productId);
      if (!product) return null;

      const color = colorPos ? getSelected('color') : null;
      const size = sizePos ? getSelected('size') : null;

      const variant =
        product.variants.find(function (v) {
          return variantMatchesOptions(v, color, size);
        }) ||
        product.variants.find(function (v) {
          return v.available;
        }) ||
        product.variants[0];

      if (!variant) return null;

      return Object.assign({}, variant, { productId: product.id });
    }

    function findBundleProductVariant(productId) {
      return resolveBundleProductVariant(productId);
    }

    function parseProductIds(rawIds) {
      if (!rawIds) return [];
      return rawIds
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean);
    }

    function findBundlePairVariants(productIds) {
      return parseProductIds(productIds).map(resolveBundleProductVariant).filter(Boolean);
    }

    function combineVariants(variantList) {
      if (!variantList.length) return null;

      let price = 0;
      let compareAt = 0;

      variantList.forEach(function (v) {
        price += v.price;
        compareAt += v.compare_at_price > v.price ? v.compare_at_price : v.price;
      });

      return {
        id: variantList[0].id,
        available: variantList.every(function (v) {
          return v.available;
        }),
        price: price,
        compare_at_price: compareAt > price ? compareAt : 0
      };
    }

    function findVariant() {
      const setInput = getSelectedSetInput();
      if (useBundleProducts && setInput) {
        const setType = getSetType(setInput);

        if (setType === 'bundle') {
          return combineVariants(findBundlePairVariants(getBundlePairProductIds(setInput)));
        }
        if (setType === 'product') {
          return findBundleProductVariant(setInput.getAttribute('data-product-id'));
        }
      }

      const color = colorPos ? getSelected('color') : null;
      const size = sizePos ? getSelected('size') : null;
      const set = setPos ? getSelected('set') : null;

      return variants.find(function (v) {
        if (colorPos && optionValue(v, colorPos) !== color) return false;
        if (sizePos && optionValue(v, sizePos) !== size) return false;
        if (setPos && optionValue(v, setPos) !== set) return false;
        return true;
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateSizeInfo() {
      const sizeInfoWrap = root.querySelector('[data-kv-size-info]');
      const sizeInfoTextEl = root.querySelector('[data-kv-size-info-text]');
      if (!sizeInfoTextEl) return;

      const checkedSize = root.querySelector('[data-kv-bundle-size]:checked');
      const text = checkedSize && checkedSize.dataset.sizeInfo ? checkedSize.dataset.sizeInfo : '';

      sizeInfoTextEl.textContent = text;
      if (sizeInfoWrap) sizeInfoWrap.hidden = !text;
    }

    function updateSizeIcons() {
      if (!sizePos) return;

      const color = colorPos ? getSelected('color') : null;

      root.querySelectorAll('[data-kv-bundle-size]').forEach(function (input) {
        const sizeValue = input.value;
        const iconWrap = input.parentElement
          ? input.parentElement.querySelector('[data-kv-size-icon]')
          : null;
        if (!iconWrap) return;

        let imgEl = iconWrap.querySelector('.kv-bundle__size-icon-img');
        let fallbackEl = iconWrap.querySelector('.kv-bundle__size-icon-fallback');

        const variant = variants.find(function (v) {
          if (color && [v.option1, v.option2, v.option3].indexOf(color) === -1) {
            return false;
          }
          return optionValue(v, sizePos) === sizeValue;
        });

        const imageUrl = variant && variant.variant_image ? variant.variant_image : null;

        if (imageUrl) {
          if (!imgEl) {
            imgEl = document.createElement('img');
            imgEl.className = 'kv-bundle__size-icon-img';
            imgEl.width = 48;
            imgEl.height = 32;
            imgEl.alt = '';
            iconWrap.insertBefore(imgEl, iconWrap.firstChild);
          }
          imgEl.src = imageUrl;
          imgEl.hidden = false;
          if (fallbackEl) fallbackEl.hidden = true;
        } else {
          if (imgEl) imgEl.hidden = true;
          if (fallbackEl) fallbackEl.hidden = false;
        }
      });
    }

    function updateSizePromoLabels() {
      if (!sizePos) return;

      const color = colorPos ? getSelected('color') : null;

      root.querySelectorAll('[data-kv-bundle-size]').forEach(function (input) {
        const sizeValue = input.value;
        const item = input.closest('.kv-bundle__size-item');
        const label = item ? item.querySelector('.kv-bundle__size-btn') : null;
        if (!label) return;

        const sizeLabelEl = label.querySelector('.kv-bundle__size-label');
        const promoEl = label.querySelector('.kv-bundle__size-promo');

        const variant = variants.find(function (v) {
          if (color && [v.option1, v.option2, v.option3].indexOf(color) === -1) {
            return false;
          }
          return optionValue(v, sizePos) === sizeValue;
        });

        const promoText = variant && variant.size_promo_label ? variant.size_promo_label : '';

        if (promoText) {
          if (promoEl) {
            promoEl.textContent = promoText;
            promoEl.hidden = false;
          }
          if (item) item.classList.add('kv-bundle__size-item--promo');
          label.classList.add('kv-bundle__size-btn--promo');
          if (sizeLabelEl) sizeLabelEl.classList.add('kv-bundle__size-label--promo');
        } else {
          if (promoEl) {
            promoEl.textContent = '';
            promoEl.hidden = true;
          }
          if (item) item.classList.remove('kv-bundle__size-item--promo');
          label.classList.remove('kv-bundle__size-btn--promo');
          if (sizeLabelEl) sizeLabelEl.classList.remove('kv-bundle__size-label--promo');
        }
      });
    }

    function updateSelectedClasses() {
      root.querySelectorAll('.kv-bundle__color-swatch').forEach(function (el) {
        el.classList.remove('kv-bundle__color-swatch--selected');
      });
      root.querySelectorAll('[data-kv-bundle-color]:checked').forEach(function (input) {
        const label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-bundle__color-swatch--selected');
      });

      root.querySelectorAll('.kv-bundle__size-btn').forEach(function (el) {
        el.classList.remove('kv-bundle__size-btn--selected');
      });
      root.querySelectorAll('[data-kv-bundle-size]:checked').forEach(function (input) {
        const label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-bundle__size-btn--selected');
      });

      root.querySelectorAll('.kv-bundle__set-card').forEach(function (el) {
        el.classList.remove('kv-bundle__set-card--selected');
      });
      root.querySelectorAll('[data-kv-bundle-set]:checked').forEach(function (input) {
        const label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-bundle__set-card--selected');
      });

      const firstSetInput = root.querySelector('[data-kv-set-first]');
      if (firstSetInput) {
        const firstSetLabel = root.querySelector('label[for="' + firstSetInput.id + '"]');
        if (firstSetLabel) firstSetLabel.classList.add('kv-bundle__set-card--featured');
      }
    }

    function ensureFirstSetSelected() {
      const setRadios = root.querySelectorAll('[data-kv-bundle-set]');
      if (!setRadios.length) return;

      const firstSet = root.querySelector('[data-kv-set-first]') || setRadios[0];
      const checked = root.querySelectorAll('[data-kv-bundle-set]:checked');

      if (checked.length !== 1) {
        setRadios.forEach(function (input) {
          input.checked = input === firstSet;
        });
      }
    }

    function updatePricingEl(pricingEl, pricing) {
      const priceEl = getSetPriceEl(pricingEl);
      const compareEl = getSetCompareEl(pricingEl);
      if (!pricing || !priceEl) return;

      applyDisplayPricingToElements(priceEl, compareEl, pricing, 1);
    }

    function updateSetCardPrices() {
      const color = colorPos ? getSelected('color') : null;
      const size = sizePos ? getSelected('size') : null;

      root.querySelectorAll('[data-kv-set-pricing]').forEach(function (pricingEl) {
        if (pricingEl.hasAttribute('data-set-bundle')) {
          const pricing = getBundlePairPricing(pricingEl);
          updatePricingEl(pricingEl, pricing);
          if (isBundleSetSelected()) {
            applyBundlePairAtcPricing(pricing);
          }
          return;
        }

        const productIdValue = pricingEl.getAttribute('data-product-id');
        if (productIdValue) {
          const variant = findBundleProductVariant(productIdValue);
          updatePricingEl(
            pricingEl,
            variant ? getSingleVariantDisplayPricing(variant, variant.productId) : null
          );
          return;
        }

        const setValue = pricingEl.dataset.setValue;
        const variant = variants.find(function (v) {
          if (colorPos && optionValue(v, colorPos) !== color) return false;
          if (sizePos && optionValue(v, sizePos) !== size) return false;
          if (setPos && optionValue(v, setPos) !== setValue) return false;
          return true;
        });
        updatePricingEl(pricingEl, variant ? getSingleVariantDisplayPricing(variant, productId) : null);
      });

      updateIncludedPrices();
    }

    function updateIncludedPrices() {
      const includedRoot = root.querySelector('[data-kv-set-included]');
      if (!includedRoot) return;

      const set1ProductId = includedRoot.getAttribute('data-set1-product-id');
      const set2Ids = parseProductIds(includedRoot.getAttribute('data-set2-product-ids') || '');
      if (!set1ProductId || set2Ids.length < 2) return;

      const set1Variant = findBundleProductVariant(set1ProductId);
      const set2Variant1 = findBundleProductVariant(set2Ids[0]);
      const set2Variant2 = findBundleProductVariant(set2Ids[1]);
      if (!set1Variant || !set2Variant1 || !set2Variant2) return;

      const set1Pricing = getSingleVariantDisplayPricing(set1Variant, set1Variant.productId);
      const set2Pricing1 = getSingleVariantDisplayPricing(set2Variant1, set2Variant1.productId);
      const set2Pricing2 = getSingleVariantDisplayPricing(set2Variant2, set2Variant2.productId);
      if (!set1Pricing || !set2Pricing1 || !set2Pricing2) return;

      const price1 = Number(set2Pricing1.price) || 0;
      const price2 = Number(set2Pricing2.price) || 0;
      const remainder = Math.max(0, (Number(set1Pricing.price) || 0) - price1 - price2);

      includedRoot.querySelectorAll('[data-kv-included-price]').forEach(function (el) {
        const source = el.getAttribute('data-source');
        let cents = 0;

        if (source === 'set2-1') cents = price1;
        else if (source === 'set2-2') cents = price2;
        else if (source === 'remainder') cents = remainder;

        el.setAttribute('data-price', String(cents));
        el.textContent = formatMoney(cents);
        el.hidden = cents <= 0;
      });
    }

    function setAtcLabel(soldOut) {
      if (!atcLabelEl) return;
      atcLabelEl.textContent = soldOut ? atcSoldOutLabel : atcDefaultLabel;
    }

    function isComboAvailable(color, size) {
      return variants.some(function (v) {
        if (!v.available) return false;
        const opts = [v.option1, v.option2, v.option3];
        if (color && opts.indexOf(color) === -1) return false;
        if (size && opts.indexOf(size) === -1) return false;
        return true;
      });
    }

    function updateOptionAvailability() {
      if (!variants.length) return;

      const selectedColor = colorPos ? getSelected('color') : null;

      if (sizePos) {
        sizeInputs.forEach(function (input) {
          const available = isComboAvailable(selectedColor, input.value);
          const label = root.querySelector('label[for="' + input.id + '"]');
          input.disabled = !available;
          if (label) {
            label.classList.toggle('kv-bundle__size-btn--unavailable', !available);
          }
        });
      }

      if (colorPos) {
        colorInputs.forEach(function (input) {
          const available = isComboAvailable(input.value, null);
          const item = input.closest('.kv-bundle__color-item');
          input.disabled = !available;
          if (item) {
            item.classList.toggle('kv-bundle__color-item--unavailable', !available);
          }
        });
      }
    }

    function updateAtcState() {
      syncAtcPriceFromSelectedSetCard();
    }

    function getBundlePairProductIds(setInput) {
      const selectedInput = setInput || getSelectedSetInput();
      if (!selectedInput) return '';

      const attrIds = selectedInput.getAttribute('data-product-ids');
      if (attrIds) return attrIds;

      const pricingEl = root.querySelector('[data-set-bundle][data-product-ids]');
      return pricingEl ? pricingEl.getAttribute('data-product-ids') || '' : '';
    }

    function getBundlePairCartLineItems(productIds) {
      const ids = parseProductIds(productIds);
      if (!ids.length) return [];

      const lineItems = ids
        .map(function (productId) {
          const variant = resolveBundleProductVariant(productId);
          if (!variant || !variant.available) return null;
          return { id: Number(variant.id), quantity: 1 };
        })
        .filter(Boolean);

      if (lineItems.length !== ids.length) return [];
      return lineItems;
    }

    function isBundlePairSelectionAvailable(productIds) {
      const ids = parseProductIds(productIds);
      if (ids.length < 2) return false;
      return getBundlePairCartLineItems(productIds).length === ids.length;
    }

    function clearMainFormVariantId() {
      if (!form) return;

      const idInput =
        form.querySelector('input[name="id"]') ||
        form.querySelector('input[data-kv-bundle-id-detached]');

      if (!idInput) return;

      idInput.removeAttribute('name');
      idInput.setAttribute('data-kv-bundle-id-detached', '');
      idInput.value = '';
    }

    function syncMainFormVariantId(variantId) {
      if (!form || !variantId) return;

      let idInput =
        form.querySelector('input[name="id"]') ||
        form.querySelector('input[data-kv-bundle-id-detached]');

      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        form.appendChild(idInput);
      }

      idInput.setAttribute('name', 'id');
      idInput.removeAttribute('data-kv-bundle-id-detached');
      idInput.value = String(variantId);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getCartLineItems() {
      const setInput = getSelectedSetInput();
      if (!setInput) return [];

      if (useBundleProducts && getSetType(setInput) === 'bundle') {
        return getBundlePairCartLineItems(getBundlePairProductIds(setInput));
      }

      if (useBundleProducts && getSetType(setInput) === 'product') {
        const variant = findBundleProductVariant(setInput.getAttribute('data-product-id'));
        if (!variant || !variant.available) return [];
        return [{ id: Number(variant.id), quantity: 1 }];
      }

      const variant = findVariant();
      if (!variant || !variant.available) return [];
      return [{ id: Number(variant.id), quantity: 1 }];
    }

    function syncVariant() {
      const setInput = getSelectedSetInput();
      const variant = findVariant();
      if (!variant) return;

      updateSetCardPrices();
      updateAtcState();

      const shouldSyncMainForm =
        form && (!useBundleProducts || (setInput && getSetType(setInput) === 'product'));

      if (useBundleProducts && setInput && getSetType(setInput) === 'bundle') {
        clearMainFormVariantId();
      } else if (shouldSyncMainForm) {
        syncMainFormVariantId(variant.id);
      }

      const productEl = root.closest('ds-main-product');
      if (productEl) {
        productEl.dispatchEvent(
          new CustomEvent('kv-bundle:variant-change', {
            bubbles: true,
            detail: {
              variant: variant,
              lineItems: getCartLineItems()
            }
          })
        );
      }
    }

    function showAtcMessage(text, isSuccess) {
      if (!atcMessageEl) return;
      atcMessageEl.textContent = text;
      atcMessageEl.hidden = !text;
      atcMessageEl.classList.toggle('kv-bundle__atc-message--success', !!isSuccess);
    }

    function getShopifySectionKey(element) {
      if (!element) return null;
      const section = element.closest('[id^="shopify-section-"]');
      if (!section || !section.id) return null;
      return section.id.replace('shopify-section-', '');
    }

    function openAjaxCartDrawer() {
      const cartBtn = document.getElementById('ajaxCartBtn');
      if (cartBtn) {
        cartBtn.click();
        return;
      }

      const cartDrawer = document.getElementById('ajaxCart');
      const overlay = document.getElementById('aboveHeaderOverlay');
      if (!cartDrawer) return;

      cartDrawer.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cartDrawer.classList.add('is-visible');
          if (overlay) overlay.classList.add('is-visible');

          const content = document.getElementById('ajaxCartContent');
          if (content) {
            content.setAttribute('tabindex', '0');
            content.focus();
          }
        });
      });

      document.body.style.overflow = 'hidden';
    }

    async function refreshCartDrawer(cartData) {
      const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const baseUrl = cartRoot.replace(/\/?$/, '/');
      const cart =
        cartData && cartData.items
          ? cartData
          : await fetch(baseUrl + 'cart.js', {
              credentials: 'include',
              headers: { Accept: 'application/json' }
            }).then(function (res) {
              return res.json();
            });

      const sectionKeys = getCartSectionIds();

      if (sectionKeys.length && (!cart.sections || !Object.keys(cart.sections).length)) {
        cart.sections = await fetch(baseUrl + '?sections=' + sectionKeys.join(','), {
          credentials: 'include',
          headers: { Accept: 'application/json' }
        }).then(function (res) {
          return res.json();
        });
      }

      if (window.EventBus && typeof window.EventBus.emit === 'function') {
        window.EventBus.emit('cart:updated', cart);
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        })
      );
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart
        })
      );

      return cart;
    }

    function getCartSectionIds() {
      const sectionKeys = [];
      const cartSectionKey = getShopifySectionKey(document.getElementById('ajaxCart'));
      const headerSectionKey = getShopifySectionKey(document.getElementById('ajaxCartBtn'));

      if (cartSectionKey) sectionKeys.push(cartSectionKey);
      if (headerSectionKey && sectionKeys.indexOf(headerSectionKey) === -1) {
        sectionKeys.push(headerSectionKey);
      }

      return sectionKeys;
    }

    async function addToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const setInput = getSelectedSetInput();
      const lineItems = getCartLineItems();
      if (!lineItems.length) {
        if (useBundleProducts && setInput && getSetType(setInput) === 'bundle') {
          showAtcMessage('Please select available options for both products.', false);
        }
        return;
      }

      if (useBundleProducts && setInput && getSetType(setInput) === 'bundle') {
        const productIds = getBundlePairProductIds(setInput);
        if (!isBundlePairSelectionAvailable(productIds)) {
          showAtcMessage('One or more selected products are unavailable.', false);
          return;
        }
      } else {
        const variant = findVariant();
        if (!variant || !variant.available) return;
      }

      if (atcBtn) atcBtn.disabled = true;
      showAtcMessage('', false);

      const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const baseUrl = cartRoot.replace(/\/?$/, '/');
      const sectionIds = getCartSectionIds();

      try {
        let cartData = null;

        if (typeof window.addItemsToCart === 'function') {
          cartData = await window.addItemsToCart(lineItems, false, sectionIds.length ? { sections: sectionIds } : {});
        } else {
          const body = { items: lineItems };
          if (sectionIds.length) body.sections = sectionIds;

          const response = await fetch(baseUrl + 'cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(body)
          });

          cartData = await response.json();
          if (!response.ok) {
            throw new Error((cartData && cartData.description) || 'Could not add to cart');
          }
        }

        await refreshCartDrawer(cartData);
        openAjaxCartDrawer();

        const addedMessage =
          (window.fmData &&
            window.fmData.cartStrings &&
            window.fmData.cartStrings.added) ||
          'Added to cart';
        showAtcMessage(addedMessage, true);
      } catch (err) {
        showAtcMessage(err.message || 'Could not add to cart', false);
      } finally {
        updateAtcState();
      }
    }

    function onChange(event) {
      updateSelectedClasses();
      updateOptionAvailability();
      updateSizeIcons();
      updateSizePromoLabels();
      updateSizeInfo();
      updateSetCardPrices();
      syncVariant();

      if (
        isBundleSetSelected() ||
        (event && event.target && event.target.hasAttribute('data-kv-bundle-set'))
      ) {
        scheduleIgPriceRefresh();
      } else if (window.igData && window.igData.price) {
        window.setTimeout(refreshIgPrices, 150);
        window.setTimeout(refreshIgPrices, 750);
      }

      if (event && event.target && event.target.hasAttribute('data-kv-bundle-color')) {
        updateProductGallery();
      }
    }

    root.querySelectorAll('.kv-bundle__color-item').forEach(function (item) {
      item.addEventListener('click', function (event) {
        const input = item.querySelector('[data-kv-bundle-color]');
        if (!input || event.target === input || input.disabled) return;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    colorInputs.forEach(function (input) {
      input.addEventListener('change', onChange);
    });
    sizeInputs.forEach(function (input) {
      input.addEventListener('change', onChange);
    });
    setInputs.forEach(function (input) {
      input.addEventListener('change', onChange);
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', addToCart);
    }

    if (form) {
      form.addEventListener(
        'change',
        function (event) {
          if (!isBundleSetSelected()) return;
          if (event.target && event.target.hasAttribute('data-kv-bundle-set')) return;
          clearMainFormVariantId();
          updateBundlePairUi();
          ensureBundleAtcPriceAfterIg();
        },
        true
      );

      form.addEventListener(
        'submit',
        function (event) {
          const setInput = getSelectedSetInput();
          if (!useBundleProducts || !setInput || getSetType(setInput) !== 'bundle') return;
          event.preventDefault();
          event.stopPropagation();
          addToCart(event);
        },
        true
      );
    }

    ensureFirstSetSelected();
    updateSelectedClasses();
    updateOptionAvailability();
    updateSizeIcons();
    updateSizePromoLabels();
    updateSizeInfo();
    updateSetCardPrices();
    syncVariant();
    updateProductGallery();
    watchBundleAtcTextFromCents();

    const igPollStarted = Date.now();
    const igPoll = setInterval(function () {
      if (window.igData && window.igData.price) {
        clearInterval(igPoll);
        scheduleIgPriceRefresh();
        return;
      }
      if (Date.now() - igPollStarted > 15000) clearInterval(igPoll);
    }, 100);

    if (window.EventBus && typeof window.EventBus.on === 'function') {
      window.EventBus.on('product:update', function () {
        if (!isBundleSetSelected()) return;
        window.setTimeout(function () {
          updateBundlePairUi();
          ensureBundleAtcPriceAfterIg();
        }, 0);
      });
    }

    document.addEventListener(
      'change',
      function (event) {
        if (!root.contains(event.target)) return;
        if (!isBundleSetSelected()) return;
        if (
          event.target.matches(
            '.js-ms-main-color-option, .js-product-option, [data-kv-bundle-color], [data-kv-bundle-size], [data-kv-bundle-set]'
          )
        ) {
          window.setTimeout(function () {
            updateBundlePairUi();
            ensureBundleAtcPriceAfterIg();
          }, 0);
        }
      },
      true
    );
  }

  document.querySelectorAll('[data-kv-bundle]').forEach(initKvBundle);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-kv-bundle]').forEach(initKvBundle);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kv-bedding-sheet"] && !Shopify.designMode) return;
  try {
    (function () {
  function initKvSheet(root) {
    if (!root || root.dataset.kvSheetInit === 'true') return;
    root.dataset.kvSheetInit = 'true';

    const formId = root.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const variantsEl = root.querySelector('[data-kv-sheet-variants]');
    const atcBtn = root.querySelector('[data-kv-sheet-atc]');
    const atcPriceEl = root.querySelector('[data-kv-sheet-atc-price]');
    const atcCompareEl = root.querySelector('[data-kv-sheet-atc-compare]');
    const atcLabelEl = root.querySelector('[data-kv-sheet-atc-label]');
    const atcSeparatorEl = root.querySelector('[data-kv-sheet-atc-separator]');
    const atcPricesWrap = root.querySelector('[data-kv-sheet-atc-prices]');
    const atcMessageEl = root.querySelector('[data-kv-sheet-atc-message]');
    const qtyInput = root.querySelector('[data-kv-sheet-qty-input]');

    const atcDefaultLabel = root.dataset.atcLabel || 'ADD TO CART';
    const atcSoldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const klaviyoBisEnable = root.dataset.klaviyoBis === 'true';
    const klaviyoBisLabel = root.dataset.klaviyoBisLabel || 'Notify me when available';
    const productId = root.dataset.productId;

    function getIgRawPrice(igPriceApi, variantId, productIdValue) {
      if (!igPriceApi) return null;

      let raw = null;
      if (typeof igPriceApi.getPriceByVariantId === 'function') {
        raw = igPriceApi.getPriceByVariantId(String(variantId));
      }
      if (
        (raw == null || raw === '') &&
        typeof igPriceApi.getPriceByProductIdAndVariantId === 'function' &&
        productIdValue
      ) {
        raw = igPriceApi.getPriceByProductIdAndVariantId(String(productIdValue), String(variantId));
      }
      return raw;
    }

    function getIgRawComparePrice(igPriceApi, variantId, productIdValue) {
      if (!igPriceApi) return null;

      let raw = null;
      if (typeof igPriceApi.getComparePriceByVariantId === 'function') {
        raw = igPriceApi.getComparePriceByVariantId(String(variantId));
      }
      if (
        (raw == null || raw === '') &&
        typeof igPriceApi.getComparePriceByProductIdAndVariantId === 'function' &&
        productIdValue
      ) {
        raw = igPriceApi.getComparePriceByProductIdAndVariantId(String(productIdValue), String(variantId));
      }
      return raw;
    }

    function parseIgMoneyToCents(raw, fallbackCents) {
      if (raw == null || raw === '') return fallbackCents;
      if (typeof raw === 'number' && Number.isFinite(raw)) {
        return Number.isInteger(raw) && raw >= 100 ? raw : Math.round(raw * 100);
      }

      const normalized = String(raw).trim();
      if (!normalized) return fallbackCents;

      const digits = normalized.replace(/[^0-9.]/g, '');
      if (!digits) return fallbackCents;

      const dollars = parseFloat(digits);
      return Number.isFinite(dollars) ? Math.round(dollars * 100) : fallbackCents;
    }

    function igPriceCents(variantId, fallback, productIdValue) {
      const igPriceApi = window.igData && window.igData.price;
      return parseIgMoneyToCents(getIgRawPrice(igPriceApi, variantId, productIdValue || productId), fallback);
    }

    function igCompareCents(variantId, fallback, productIdValue) {
      const igPriceApi = window.igData && window.igData.price;
      return parseIgMoneyToCents(
        getIgRawComparePrice(igPriceApi, variantId, productIdValue || productId),
        fallback
      );
    }

    function applyIgPriceAttributes(el, variantId, productIdValue, unitPriceCents, multiplier) {
      if (!el) return;

      el.setAttribute('data-price', String(unitPriceCents));
      el.setAttribute('data-price-multiplier', String(multiplier || 1));
      if (variantId) el.setAttribute('data-variant-id', String(variantId));
      if (productIdValue) el.setAttribute('data-product-id', String(productIdValue));
    }

    function getVariantDisplayPricing(variant, qty) {
      if (!variant) return null;

      const quantity = qty || 1;
      const unitPrice = igPriceCents(variant.id, variant.price, productId);
      const unitCompare = igCompareCents(variant.id, variant.compare_at_price || 0, productId);

      return {
        unitPrice: unitPrice,
        unitCompare: unitCompare,
        totalPrice: unitPrice * quantity,
        totalCompare: unitCompare * quantity,
        onSale: unitCompare > unitPrice,
        quantity: quantity
      };
    }

    function refreshIgPrices() {
      updateAtcState();
    }

    let variants = [];
    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    const colorPos = parseInt(root.dataset.colorPosition, 10) || 0;
    const sizePos = parseInt(root.dataset.sizePosition, 10) || 0;

    const colorInputs = root.querySelectorAll('[data-kv-sheet-color]');
    const sizeInputs = root.querySelectorAll('[data-kv-sheet-size]');

    function getSelected(type) {
      if (type === 'color') {
        const input = root.querySelector('[data-kv-sheet-color]:checked');
        return input ? input.value : null;
      }
      const input = root.querySelector('[data-kv-sheet-size]:checked');
      return input ? input.value : null;
    }

    function optionValue(variant, position) {
      if (position === 1) return variant.option1;
      if (position === 2) return variant.option2;
      if (position === 3) return variant.option3;
      return null;
    }

    function findVariant() {
      const color = colorPos ? getSelected('color') : null;
      const size = sizePos ? getSelected('size') : null;

      return variants.find(function (v) {
        if (colorPos && optionValue(v, colorPos) !== color) return false;
        if (sizePos && optionValue(v, sizePos) !== size) return false;
        return true;
      });
    }

    function findVariantById(variantId) {
      if (!variantId) return null;
      const id = Number(variantId);
      return variants.find(function (v) {
        return Number(v.id) === id;
      }) || null;
    }

    function getUrlVariantId() {
      try {
        const value = new URL(window.location.href).searchParams.get('variant');
        if (value) return String(value);
      } catch (e) {}

      const idInput = getProductFormIdInput();
      if (idInput) {
        const stored = idInput.getAttribute('data-kv-sheet-url-variant');
        if (stored) return String(stored);
      }

      return null;
    }

    function getProductFormIdInput() {
      if (!form) return null;
      return (
        form.querySelector('input[name="id"]') ||
        form.querySelector('input[data-kv-sheet-id-detached]')
      );
    }

    function syncProductFormVariantId(variantId) {
      if (!variantId) return;

      const value = String(variantId);
      const idInput = getProductFormIdInput();

      if (idInput) {
        idInput.setAttribute('name', 'id');
        idInput.removeAttribute('data-kv-sheet-id-detached');
        idInput.value = value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      if (!formId) return;

      let syncInput = root.querySelector('[data-kv-sheet-variant-id-sync]');
      if (!syncInput) {
        syncInput = document.createElement('input');
        syncInput.type = 'hidden';
        syncInput.setAttribute('data-kv-sheet-variant-id-sync', '');
        syncInput.setAttribute('form', formId);
        root.appendChild(syncInput);
      }

      syncInput.setAttribute('name', 'id');
      syncInput.value = value;
      syncInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncSheetUrlVariant(variantId) {
      if (!variantId) return;

      const nextVariantId = String(variantId);
      if (getUrlVariantId() === nextVariantId) return;

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', nextVariantId);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {}

      document.dispatchEvent(
        new CustomEvent('kv-sheet:variant-change', {
          bubbles: true,
          detail: { variantId: nextVariantId, productId: productId || null }
        })
      );
    }

    function selectVariantOptions(variant) {
      if (!variant) return;

      if (colorPos) {
        const colorValue = optionValue(variant, colorPos);
        if (colorValue) {
          colorInputs.forEach(function (input) {
            if (input.value === colorValue) {
              input.disabled = false;
              input.checked = true;
            }
          });
        }
      }

      if (sizePos) {
        const sizeValue = optionValue(variant, sizePos);
        if (sizeValue) {
          sizeInputs.forEach(function (input) {
            if (input.value === sizeValue) {
              input.disabled = false;
              input.checked = true;
            }
          });
        }
      }
    }

    function applyUrlVariantOnInit() {
      const urlVariantId = getUrlVariantId();
      if (!urlVariantId) return;

      const variant = findVariantById(urlVariantId);
      if (!variant) return;

      selectVariantOptions(variant);
    }

    function setAtcIntegrationMode(mode) {
      if (!atcBtn) return;

      atcBtn.classList.remove('add-to-cart-button', 'klaviyo-bis-trigger');
      atcBtn.removeAttribute('data-klaviyo-bis-button-text');

      if (mode === 'ready' || mode === 'klaviyo') {
        atcBtn.classList.add('add-to-cart-button');
      }

      if (mode === 'klaviyo') {
        atcBtn.classList.add('klaviyo-bis-trigger');
        atcBtn.setAttribute('data-klaviyo-bis-button-text', klaviyoBisLabel);
      } else if (klaviyoBisEnable) {
        atcBtn.setAttribute('data-klaviyo-bis-button-text', klaviyoBisLabel);
      }
    }

    function setAtcKlaviyoMode(isKlaviyo, variantId) {
      if (!atcBtn) return;

      if (isKlaviyo && variantId) {
        const notifyVariantId = String(variantId);

        setAtcIntegrationMode('klaviyo');
        atcBtn.classList.remove('is-disabled');
        atcBtn.disabled = false;
        if (atcLabelEl) atcLabelEl.textContent = klaviyoBisLabel;
        setAtcPricesVisible(false);
        syncProductFormVariantId(notifyVariantId);
        if (atcPriceEl) atcPriceEl.setAttribute('data-variant-id', notifyVariantId);
        syncSheetUrlVariant(notifyVariantId);
        return;
      }

      setAtcIntegrationMode('ready');
    }

    function setAtcPricesVisible(isVisible) {
      if (atcSeparatorEl) atcSeparatorEl.hidden = !isVisible;
      if (atcPricesWrap) atcPricesWrap.hidden = !isVisible;
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateSelectedClasses() {
      root.querySelectorAll('.kv-sheet__color-swatch').forEach(function (el) {
        el.classList.remove('kv-sheet__color-swatch--selected');
      });
      root.querySelectorAll('[data-kv-sheet-color]:checked').forEach(function (input) {
        const label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-sheet__color-swatch--selected');
      });

      root.querySelectorAll('.kv-sheet__size-btn').forEach(function (el) {
        el.classList.remove('kv-sheet__size-btn--selected');
      });
      root.querySelectorAll('[data-kv-sheet-size]:checked').forEach(function (input) {
        const label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-sheet__size-btn--selected');
      });
    }

    function findSizeInfoText(size, color) {
      let exact = '';
      let sizeFallback = '';

      variants.forEach(function (item) {
        const options = [item.option1, item.option2, item.option3];
        if (size && options.indexOf(size) === -1) return;
        const text = item.info_text ? String(item.info_text) : '';
        if (!text) return;
        if (!sizeFallback) sizeFallback = text;
        if (color && options.indexOf(color) === -1) return;
        if (!exact) exact = text;
      });

      if (exact) return exact;
      if (sizeFallback) return sizeFallback;

      const sizeInput = root.querySelector('[data-kv-sheet-size]:checked');
      return sizeInput ? sizeInput.getAttribute('data-size-info') || '' : '';
    }

    function updateSizeInfo() {
      const sizeInfoWrap = root.querySelector('[data-kv-sheet-size-info]');
      const sizeInfoTextEl = root.querySelector('[data-kv-sheet-size-info-text]');
      if (!sizeInfoTextEl) return;

      const color = colorPos ? getSelected('color') : null;
      const size = sizePos ? getSelected('size') : null;
      const text = findSizeInfoText(size, color);

      sizeInfoTextEl.textContent = text;
      if (sizeInfoWrap) sizeInfoWrap.hidden = !text;
    }

    function updateSizeIcons() {
      if (!sizePos) return;

      const color = colorPos ? getSelected('color') : null;

      root.querySelectorAll('[data-kv-sheet-size]').forEach(function (input) {
        const sizeValue = input.value;
        const iconWrap = input.parentElement
          ? input.parentElement.querySelector('[data-kv-sheet-size-icon]')
          : null;
        if (!iconWrap) return;

        let imgEl = iconWrap.querySelector('.kv-sheet__size-icon-img');
        let fallbackEl = iconWrap.querySelector('.kv-sheet__size-icon-fallback');

        const variant = variants.find(function (v) {
          if (color && [v.option1, v.option2, v.option3].indexOf(color) === -1) {
            return false;
          }
          return optionValue(v, sizePos) === sizeValue;
        });

        const imageUrl = variant && variant.variant_image ? variant.variant_image : null;

        if (imageUrl) {
          if (!imgEl) {
            imgEl = document.createElement('img');
            imgEl.className = 'kv-sheet__size-icon-img';
            imgEl.width = 36;
            imgEl.height = 36;
            imgEl.alt = '';
            iconWrap.insertBefore(imgEl, iconWrap.firstChild);
          }
          imgEl.src = imageUrl;
          imgEl.hidden = false;
          if (fallbackEl) fallbackEl.hidden = true;
        } else {
          if (imgEl) imgEl.hidden = true;
          if (fallbackEl) fallbackEl.hidden = false;
        }
      });
    }

    function updateSizePromoLabels() {
      if (!sizePos) return;

      const color = colorPos ? getSelected('color') : null;

      root.querySelectorAll('[data-kv-sheet-size]').forEach(function (input) {
        const sizeValue = input.value;
        const item = input.closest('.kv-sheet__size-item');
        const label = item ? item.querySelector('.kv-sheet__size-btn') : null;
        if (!label) return;

        const sizeLabelEl = label.querySelector('.kv-sheet__size-label');
        const promoEl = label.querySelector('.kv-sheet__size-promo');

        const variant = variants.find(function (v) {
          if (color && [v.option1, v.option2, v.option3].indexOf(color) === -1) {
            return false;
          }
          return optionValue(v, sizePos) === sizeValue;
        });

        const promoText = variant && variant.size_promo_label ? variant.size_promo_label : '';

        if (promoText) {
          if (promoEl) {
            promoEl.textContent = promoText;
            promoEl.hidden = false;
          }
          if (item) item.classList.add('kv-sheet__size-item--promo');
          label.classList.add('kv-sheet__size-btn--promo');
          if (sizeLabelEl) sizeLabelEl.classList.add('kv-sheet__size-label--promo');
        } else {
          if (promoEl) {
            promoEl.textContent = '';
            promoEl.hidden = true;
          }
          if (item) item.classList.remove('kv-sheet__size-item--promo');
          label.classList.remove('kv-sheet__size-btn--promo');
          if (sizeLabelEl) sizeLabelEl.classList.remove('kv-sheet__size-label--promo');
        }
      });
    }

    function isComboAvailable(color, size) {
      return variants.some(function (v) {
        if (!v.available) return false;
        const opts = [v.option1, v.option2, v.option3];
        if (color && opts.indexOf(color) === -1) return false;
        if (size && opts.indexOf(size) === -1) return false;
        return true;
      });
    }

    function updateOptionAvailability() {
      if (!variants.length) return;

      const selectedColor = colorPos ? getSelected('color') : null;

      sizeInputs.forEach(function (input) {
        const available = isComboAvailable(selectedColor, input.value);
        const label = root.querySelector('label[for="' + input.id + '"]');
        input.disabled = !available;
        if (label) {
          label.classList.toggle('kv-sheet__size-btn--unavailable', !available);
        }
      });

      colorInputs.forEach(function (input) {
        const available = isComboAvailable(input.value, null);
        const item = input.closest('.kv-sheet__color-item');
        input.disabled = !available;
        if (item) {
          item.classList.toggle('kv-sheet__color-item--unavailable', !available);
        }
      });
    }

    function getQuantity() {
      const val = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isNaN(val) || val < 1 ? 1 : val;
    }

    function setAtcLabel(soldOut) {
      if (!atcLabelEl) return;
      atcLabelEl.textContent = soldOut ? atcSoldOutLabel : atcDefaultLabel;
    }

    function updateAtcState() {
      const variant = findVariant();
      if (!atcBtn) return;

      const qty = getQuantity();

      if (!variant) {
        setAtcIntegrationMode('sold-out');
        atcBtn.disabled = true;
        setAtcLabel(true);
        if (atcPriceEl) atcPriceEl.textContent = '';
        if (atcCompareEl) {
          atcCompareEl.textContent = '';
          atcCompareEl.hidden = true;
        }
        setAtcPricesVisible(false);
        return;
      }

      if (!variant.available) {
        if (klaviyoBisEnable) {
          setAtcKlaviyoMode(true, variant.id);
          return;
        }

        setAtcIntegrationMode('sold-out');
        atcBtn.disabled = true;
        setAtcLabel(true);
        setAtcPricesVisible(false);
        if (atcPriceEl) atcPriceEl.textContent = '';
        if (atcCompareEl) {
          atcCompareEl.textContent = '';
          atcCompareEl.hidden = true;
        }
        syncProductFormVariantId(variant.id);
        syncSheetUrlVariant(variant.id);
        return;
      }

      setAtcIntegrationMode('ready');
      atcBtn.disabled = false;
      setAtcLabel(false);
      setAtcPricesVisible(true);

      const pricing = getVariantDisplayPricing(variant, qty);
      if (pricing && atcPriceEl) {
        atcPriceEl.textContent = formatMoney(pricing.totalPrice);
        applyIgPriceAttributes(atcPriceEl, variant.id, productId, pricing.unitPrice, qty);
      }
      if (pricing && atcCompareEl) {
        if (pricing.onSale) {
          atcCompareEl.textContent = formatMoney(pricing.totalCompare);
          applyIgPriceAttributes(atcCompareEl, variant.id, productId, pricing.unitCompare, qty);
          atcCompareEl.hidden = false;
        } else {
          atcCompareEl.textContent = '';
          atcCompareEl.hidden = true;
        }
      }
      syncProductFormVariantId(variant.id);
      syncSheetUrlVariant(variant.id);
    }

    function filterGallerySlides(slides, colorHandle) {
      const galleryHiddenClass = 'product-gallery__item--hidden';
      const galleryVisibleClass = 'js-product-gallery-slide-visible';

      slides.forEach(function (slide) {
        const swatchHandle = slide.getAttribute('data-swatch-handle') || '';
        const matches = swatchHandle === 'default' || swatchHandle.indexOf(colorHandle) !== -1;

        if (matches) {
          slide.classList.remove(galleryHiddenClass);
          slide.classList.add(galleryVisibleClass);
        } else {
          slide.classList.add(galleryHiddenClass);
          slide.classList.remove(galleryVisibleClass);
        }
      });
    }

    function updateProductGallery() {
      const checkedColor = root.querySelector('[data-kv-sheet-color]:checked');
      if (!checkedColor) return;

      const colorHandle = checkedColor.getAttribute('data-color-value-handle');
      if (!colorHandle) return;

      const productEl = root.closest('.js-product');
      if (!productEl) return;

      const slides = productEl.querySelectorAll('.js-swatch-media');
      if (!slides.length) return;

      const matchCount = Array.from(slides).reduce(function (count, slide) {
        const handle = slide.getAttribute('data-swatch-handle') || '';
        return handle.indexOf(colorHandle) !== -1 ? count + 1 : count;
      }, 0);

      filterGallerySlides(slides, matchCount === 0 ? 'default' : colorHandle);

      const gallery = productEl.querySelector('.js-product-gallery');
      if (gallery && gallery.o && typeof gallery.o.setupSlideshow === 'function') {
        gallery.o.setupSlideshow();
      }
    }

    function syncVariant() {
      updateAtcState();
    }

    function getShopifySectionKey(element) {
      if (!element) return null;
      const section = element.closest('[id^="shopify-section-"]');
      if (!section || !section.id) return null;
      return section.id.replace('shopify-section-', '');
    }

    function openAjaxCartDrawer() {
      const cartBtn = document.getElementById('ajaxCartBtn');
      if (cartBtn) {
        cartBtn.click();
        return;
      }

      const cartDrawer = document.getElementById('ajaxCart');
      const overlay = document.getElementById('aboveHeaderOverlay');
      if (!cartDrawer) return;

      cartDrawer.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cartDrawer.classList.add('is-visible');
          if (overlay) overlay.classList.add('is-visible');

          const content = document.getElementById('ajaxCartContent');
          if (content) {
            content.setAttribute('tabindex', '0');
            content.focus();
          }
        });
      });

      document.body.style.overflow = 'hidden';
    }

    async function refreshCartDrawer() {
      const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const baseUrl = cartRoot.replace(/\/?$/, '/');
      const cart = await fetch(baseUrl + 'cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        return res.json();
      });

      const sectionKeys = [];
      const cartSectionKey = getShopifySectionKey(document.getElementById('ajaxCart'));
      const headerSectionKey = getShopifySectionKey(document.getElementById('ajaxCartBtn'));

      if (cartSectionKey) sectionKeys.push(cartSectionKey);
      if (headerSectionKey && sectionKeys.indexOf(headerSectionKey) === -1) {
        sectionKeys.push(headerSectionKey);
      }

      if (sectionKeys.length) {
        const sections = await fetch(baseUrl + '?sections=' + sectionKeys.join(','), {
          headers: { Accept: 'application/json' }
        }).then(function (res) {
          return res.json();
        });
        cart.sections = sections;
      }

      if (window.EventBus && typeof window.EventBus.emit === 'function') {
        window.EventBus.emit('cart:updated', cart);
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        })
      );
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart
        })
      );

      return cart;
    }

    function showAtcMessage(text, isSuccess) {
      if (!atcMessageEl) return;
      atcMessageEl.textContent = text;
      atcMessageEl.hidden = !text;
      atcMessageEl.classList.toggle('kv-sheet__atc-message--success', !!isSuccess);
    }

    async function addToCart() {
      if (atcBtn && atcBtn.classList.contains('klaviyo-bis-trigger')) return;

      const variant = findVariant();
      if (!variant || !variant.available) return;

      if (atcBtn) atcBtn.disabled = true;
      showAtcMessage('', false);

      const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const addUrl = cartRoot.replace(/\/?$/, '/') + 'cart/add.js';

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: getQuantity() }]
          })
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error((data && data.description) || 'Could not add to cart');
        }

        await refreshCartDrawer();
        openAjaxCartDrawer();

        const addedMessage =
          (window.fmData &&
            window.fmData.cartStrings &&
            window.fmData.cartStrings.added) ||
          'Added to cart';
        showAtcMessage(addedMessage, true);
      } catch (err) {
        showAtcMessage(err.message || 'Could not add to cart', false);
      } finally {
        updateAtcState();
      }
    }

    function onChange(event) {
      updateSelectedClasses();
      updateOptionAvailability();
      updateSizePromoLabels();
      updateSizeIcons();
      updateSizeInfo();
      syncVariant();

      if (event && event.target && event.target.hasAttribute('data-kv-sheet-color')) {
        updateProductGallery();
      }
    }

    root.querySelectorAll('.kv-sheet__color-item').forEach(function (item) {
      item.addEventListener('click', function (event) {
        const input = item.querySelector('[data-kv-sheet-color]');
        if (!input || event.target === input || input.disabled) return;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    colorInputs.forEach(function (input) {
      input.addEventListener('change', onChange);
    });
    sizeInputs.forEach(function (input) {
      input.addEventListener('change', onChange);
    });

    function onQtyChange() {
      updateAtcState();
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', onQtyChange);
      qtyInput.addEventListener('input', onQtyChange);
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (event) {
        if (atcBtn.classList.contains('klaviyo-bis-trigger')) return;
        event.preventDefault();
        addToCart();
      });
    }

    if (form && atcBtn) {
      form.addEventListener('submit', function (event) {
        if (event.submitter !== atcBtn) return;
        if (atcBtn.classList.contains('klaviyo-bis-trigger')) return;
        event.preventDefault();
        addToCart();
      });
    }

    applyUrlVariantOnInit();
    updateSelectedClasses();
    updateOptionAvailability();
    updateSizePromoLabels();
    updateSizeIcons();
    updateSizeInfo();
    syncVariant();
    updateProductGallery();

    const igPollStarted = Date.now();
    const igPoll = setInterval(function () {
      if (window.igData && window.igData.price) {
        clearInterval(igPoll);
        refreshIgPrices();
        return;
      }
      if (Date.now() - igPollStarted > 15000) clearInterval(igPoll);
    }, 100);
  }

  document.querySelectorAll('[data-kv-sheet]').forEach(initKvSheet);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-kv-sheet]').forEach(initKvSheet);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kv-sofa-cover-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
  function initKvScbOfferTimer(root) {
    var timer = root.querySelector('[data-kv-scb-offer-timer]');
    if (!timer || timer.dataset.kvScbOfferInit === 'true') return;
    timer.dataset.kvScbOfferInit = 'true';

    var cycleMs = 48 * 60 * 60 * 1000;
    var storageKey = 'kv-scb-offer-end';
    var daysEl = timer.querySelector('[data-kv-scb-offer-days]');
    var hoursEl = timer.querySelector('[data-kv-scb-offer-hours]');
    var minsEl = timer.querySelector('[data-kv-scb-offer-mins]');
    var secsEl = timer.querySelector('[data-kv-scb-offer-secs]');

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function getEndTime() {
      var now = Date.now();
      var stored = sessionStorage.getItem(storageKey);

      if (stored) {
        var end = parseInt(stored, 10);
        if (!isNaN(end)) {
          if (end > now) return end;
          while (end <= now) end += cycleMs;
          sessionStorage.setItem(storageKey, String(end));
          return end;
        }
      }

      var randomRemaining = Math.floor(Math.random() * cycleMs);
      var endTime = now + randomRemaining;
      sessionStorage.setItem(storageKey, String(endTime));
      return endTime;
    }

    var endTime = getEndTime();

    function tick() {
      var remaining = Math.max(0, endTime - Date.now());

      if (remaining === 0) {
        endTime = Date.now() + cycleMs;
        sessionStorage.setItem(storageKey, String(endTime));
        remaining = cycleMs;
      }

      var totalSecs = Math.floor(remaining / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;

      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initKvScbStockUrgency(root) {
    var bar = root.querySelector('[data-kv-scb-stock-urgency]');
    if (!bar || bar.dataset.kvScbStockInit === 'true') return;
    bar.dataset.kvScbStockInit = 'true';

    var storageKey = 'kv-scb-stock-urgency-fill';
    var storageTimeKey = 'kv-scb-stock-urgency-time';
    var startMin = 68;
    var startMax = 84;
    var maxFill = 95;
    var tickMs = 10000;
    var fillEl = bar.querySelector('[data-kv-scb-stock-fill]');
    var pctEl = bar.querySelector('[data-kv-scb-stock-pct]');
    var progressEl = bar.querySelector('[data-kv-scb-stock-bar]');

    function getFillPercent() {
      var now = Date.now();
      var storedFill = parseInt(sessionStorage.getItem(storageKey), 10);
      var storedTime = parseInt(sessionStorage.getItem(storageTimeKey), 10);

      if (isNaN(storedFill) || isNaN(storedTime) || storedFill < startMin || storedFill > maxFill) {
        var startFill = Math.floor(Math.random() * (startMax - startMin + 1)) + startMin;
        sessionStorage.setItem(storageKey, String(startFill));
        sessionStorage.setItem(storageTimeKey, String(now));
        return startFill;
      }

      var increases = Math.floor((now - storedTime) / tickMs);
      if (increases > 0) {
        storedFill = Math.min(maxFill, storedFill + increases);
        sessionStorage.setItem(storageKey, String(storedFill));
        sessionStorage.setItem(storageTimeKey, String(storedTime + increases * tickMs));
      }

      return storedFill;
    }

    function render(fillPct) {
      var leftPct = 100 - fillPct;
      if (fillEl) fillEl.style.width = fillPct + '%';
      if (pctEl) pctEl.textContent = leftPct + '% Left';
      if (progressEl) progressEl.setAttribute('aria-valuenow', String(leftPct));
    }

    function tick() {
      render(getFillPercent());
    }

    tick();
    setInterval(tick, tickMs);
  }

  function initKvSofaCoverBundle(root) {
    if (!root || root.dataset.kvScbInit === 'true') return;
    root.dataset.kvScbInit = 'true';

    var variants = [];
    var colorOptions = [];
    var productVariantsData = null;

    try {
      var variantsScript = root.querySelector('script[data-kv-scb-variants]');
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (e) {
      variants = [];
    }

    try {
      var colorsScript = root.querySelector('script[data-kv-scb-colors]');
      colorOptions = colorsScript ? JSON.parse(colorsScript.textContent) || [] : [];
    } catch (e2) {
      colorOptions = [];
    }

    var materialsById = {};
    try {
      var materialsScript = root.querySelector('script[data-kv-scb-materials]');
      materialsById = materialsScript ? JSON.parse(materialsScript.textContent) || {} : {};
    } catch (eMat) {
      materialsById = {};
    }

    var pvdEl = document.getElementById('productVariantsData');
    if (pvdEl) {
      try {
        productVariantsData = JSON.parse(pvdEl.textContent);
      } catch (e3) {
        productVariantsData = null;
      }
    }

    var productId = root.dataset.productId || '';
    var productHandle = root.dataset.productHandle || '';
    var blockId = root.dataset.kvScbBlockId || String(productId || 'scb');
    var colorInitialVisible = 3;
    var promoTagline = root.dataset.promoTagline || 'Spring Color';
    var tplPromo = root.querySelector('[data-kv-scb-tpl-promo]');
    var tplSale = root.querySelector('[data-kv-scb-tpl-sale]');
    var tplHot = root.querySelector('[data-kv-scb-tpl-hot]');

    function getTemplateHtml(tpl) {
      return tpl ? tpl.innerHTML : '';
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function colorExistsForModule(moduleName, colorValue) {
      if (!moduleName || !colorValue) return false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!moduleNamesMatch(v.moduleName, moduleName)) continue;
        if (v.options && v.options.indexOf(colorValue) !== -1) return true;
      }
      return false;
    }

    function buildPromoBadgesHtml(color) {
      var html = '';
      if (color.isSale) html += getTemplateHtml(tplSale);
      else if (color.isHotSeller) html += getTemplateHtml(tplHot);
      else if (color.isPromo) html += getTemplateHtml(tplPromo);
      return html;
    }

    function buildSrOnlyHtml(color) {
      var html = '';
      if (color.isSale) html += '<span class="sr-only">Sale</span>';
      else if (color.isHotSeller) html += '<span class="sr-only">Hot seller</span>';
      else if (color.isPromo) html += '<span class="sr-only">' + escapeHtml(promoTagline) + '</span>';
      return html;
    }

    function buildGlobalColorItemHtml(color, index, defaultColor, hiddenCount) {
      var isDefault = color.value === defaultColor;
      var isExtra = index + 1 > colorInitialVisible && !isDefault;
      var attrs = '';
      if (color.isPromo) attrs += ' data-promo-color';
      if (color.isSale) attrs += ' data-sale-color';
      if (color.isHotSeller) attrs += ' data-hot-seller-color';
      var badges = buildPromoBadgesHtml(color);
      var bgAttr = color.bgStyle ? ' style="' + escapeHtml(color.bgStyle) + '"' : '';
      var inputId = 'kv-scb-color-' + blockId + '-' + (index + 1);

      return (
        '<li class="kv-scb__color-item' + (isExtra ? ' kv-scb__color-item--extra' : '') + (color.unavailable ? ' kv-scb__color-item--unavailable' : '') + '">' +
          '<input type="radio" class="kv-scb__color-input visually-hidden" name="kv-scb-color-' + escapeHtml(blockId) + '" id="' + escapeHtml(inputId) + '" value="' + escapeHtml(color.value) + '" data-kv-scb-global-color data-color-value-handle="' + escapeHtml(color.handle) + '"' + (isDefault ? ' checked' : '') + attrs + '>' +
          '<label class="kv-scb__color-swatch' + (isDefault ? ' kv-scb__color-swatch--selected' : '') + '" for="' + escapeHtml(inputId) + '">' +
            '<span class="kv-scb__color-swatch-inner kv-for-color-swatch" style="' + escapeHtml(color.innerStyle) + '">' + badges + '</span>' +
            '<span class="kv-scb__color-swatch-inner kv-for-color-bg-swatch"' + bgAttr + '>' + badges + '</span>' +
            '<span class="kv-scb__color-name">' + escapeHtml(color.value) + '</span>' +
            buildSrOnlyHtml(color) +
          '</label>' +
        '</li>'
      );
    }

    function buildColorMoreHtml(hiddenCount) {
      if (hiddenCount <= 0) return '';
      return (
        '<li class="kv-scb__color-item kv-scb__color-item--more" style="display:none;">' +
          '<button type="button" class="kv-scb__color-more-btn" data-kv-scb-color-more aria-label="View ' + hiddenCount + ' more colors">' +
            '<span class="kv-scb__color-more-icon" aria-hidden="true">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M24 11.0192V12.9808H12.9808V24H11.0192V12.9808H0V11.0192H11.0192V0H12.9808V11.0192H24Z" fill="#312F2B"/></svg>' +
            '</span>' +
            '<span class="kv-scb__color-more-label">View ' + hiddenCount + ' more</span>' +
          '</button>' +
        '</li>'
      );
    }

    function rebuildColorGrid(material) {
      var grid = root.querySelector('[data-kv-scb-color-grid]');
      if (!grid || !material) return;

      var colors = material.colors || [];
      var defaultColor = material.defaultColor || (colors[0] && colors[0].value) || '';
      var hiddenCount = 0;
      var html = '';

      colors.forEach(function (color, index) {
        if (index + 1 > colorInitialVisible && color.value !== defaultColor) hiddenCount += 1;
        html += buildGlobalColorItemHtml(color, index, defaultColor, hiddenCount);
      });
      html += buildColorMoreHtml(hiddenCount);

      grid.innerHTML = html;
      grid.classList.remove('kv-scb__color-grid--expanded');
    }

    function rebuildModuleColorGrids(material) {
      var colors = (material && material.colors) || [];
      var defaultColor = (material && material.defaultColor) || (colors[0] && colors[0].value) || '';

      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        var list = cover.querySelector('[data-kv-scb-module-colors] .kv-scb__module-color-grid');
        if (!list) return;

        var moduleName = getModuleName(cover);
        var moduleHandle = cover.dataset.moduleHandle || moduleName || 'module';
        var html = '';
        var colorIndex = 0;

        colors.forEach(function (color) {
          if (!colorExistsForModule(moduleName, color.value)) return;
          colorIndex += 1;
          var inputId = 'kv-scb-mc-' + String(moduleHandle).replace(/\s+/g, '-') + '-' + colorIndex;
          var isSelected = color.value === defaultColor;
          var attrs = '';
          if (color.isPromo) attrs += ' data-promo-color';
          if (color.isSale) attrs += ' data-sale-color';
          if (color.isHotSeller) attrs += ' data-hot-seller-color';
          var badges = buildPromoBadgesHtml(color);

          html +=
            '<li class="kv-scb__color-item" data-kv-scb-color-item data-color-value="' + escapeHtml(color.value) + '">' +
              '<input type="radio" class="kv-scb__color-input visually-hidden" name="kv-scb-mcolor-' + escapeHtml(moduleHandle) + '" id="' + escapeHtml(inputId) + '" value="' + escapeHtml(color.value) + '" data-kv-scb-module-color' + (isSelected ? ' checked' : '') + attrs + '>' +
              '<label class="kv-scb__color-swatch kv-scb__color-swatch--panel' + (isSelected ? ' kv-scb__color-swatch--selected' : '') + '" for="' + escapeHtml(inputId) + '" title="' + escapeHtml(color.value) + '">' +
                '<span class="visually-hidden">' + escapeHtml(color.value) + '</span>' +
                '<span class="kv-scb__color-swatch-inner" style="' + escapeHtml(color.innerStyle) + '" aria-hidden="true">' + badges + '</span>' +
                buildSrOnlyHtml(color) +
              '</label>' +
            '</li>';
        });

        list.innerHTML = html;
      });
    }

    function setActiveMaterialTab(productIdValue) {
      root.querySelectorAll('[data-kv-scb-material-tab]').forEach(function (tab) {
        var isActive = String(tab.getAttribute('data-product-id')) === String(productIdValue);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });
    }

    function updateProductPageTitle(title) {
      if (!title) return;
      document.querySelectorAll('.product__title').forEach(function (el) {
        el.textContent = title;
      });
    }

    var productPagePartsCache = {};
    var productPagePartsPending = {};
    var mediaRefreshToken = 0;

    function captureGalleryConstructor() {
      if (window.__kvScbGalleryCtor) return;
      var gallery = document.querySelector('.js-product-gallery');
      if (gallery && gallery.o && gallery.o.constructor) {
        window.__kvScbGalleryCtor = gallery.o.constructor;
        window.__kvScbGallerySettings = gallery.o.baseSettings || null;
      }
    }

    function getMaterialProductUrl(material) {
      if (!material) return '';
      var tab = root.querySelector(
        '[data-kv-scb-material-tab][data-product-id="' + String(material.id) + '"]'
      );
      var url = tab && tab.getAttribute('data-product-url');
      if (url) return url;
      if (!material.handle) return '';
      var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return cartRoot.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(material.handle);
    }

    function reinitProductGallery(productEl) {
      var gallery = (productEl || document).querySelector('.js-product-gallery');
      if (!gallery) return;

      var SliderCtor = window.__kvScbGalleryCtor;
      if (!SliderCtor) return;

      try {
        gallery.o = new SliderCtor(
          gallery,
          window.__kvScbGallerySettings || {
            destroy: true,
            selectors: {
              slide: '.js-product-gallery-slide-visible',
              slides: '.js-product-gallery-slides'
            },
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  dots: true,
                  dotThumbnails: true,
                  ariaLabel: 'Product Gallery',
                  slidesToShow: 1,
                  carousel: false,
                  destroy: false
                }
              }
            ]
          }
        );
      } catch (e) {}
    }

    function applyProductPageParts(parts, material) {
      if (!parts) return;

      var productEl = root.closest('.js-product') || document.querySelector('.js-product');
      var mediaEl = document.querySelector('.product__media');
      var tabsEl = document.querySelector('.product__tabs');

      if (mediaEl && typeof parts.mediaHtml === 'string') {
        var oldGallery = mediaEl.querySelector('.js-product-gallery');
        if (oldGallery && oldGallery.o && typeof oldGallery.o.destroy === 'function') {
          try {
            oldGallery.o.destroy();
          } catch (e) {}
        }
        mediaEl.innerHTML = parts.mediaHtml;
      }

      if (tabsEl && typeof parts.tabsHtml === 'string') {
        tabsEl.innerHTML = parts.tabsHtml;
      }

      if (productEl && material && material.handle) {
        productEl.setAttribute('data-product-handle', material.handle);
      }

      reinitProductGallery(productEl);
      filterGallery();
    }

    function refreshProductMediaAndTabs(material) {
      if (!material) return;

      captureGalleryConstructor();

      var cacheKey = String(material.id);
      var token = ++mediaRefreshToken;
      var cached = productPagePartsCache[cacheKey];
      if (cached) {
        applyProductPageParts(cached, material);
        return;
      }

      if (productPagePartsPending[cacheKey]) {
        productPagePartsPending[cacheKey].then(function (parts) {
          if (token !== mediaRefreshToken) return;
          applyProductPageParts(parts, material);
        });
        return;
      }

      var url = getMaterialProductUrl(material);
      if (!url) return;

      productPagePartsPending[cacheKey] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var media = doc.querySelector('.product__media');
          var tabs = doc.querySelector('.product__tabs');
          var parts = {
            mediaHtml: media ? media.innerHTML : '',
            tabsHtml: tabs ? tabs.innerHTML : ''
          };
          productPagePartsCache[cacheKey] = parts;
          delete productPagePartsPending[cacheKey];
          return parts;
        })
        .catch(function () {
          delete productPagePartsPending[cacheKey];
          return null;
        });

      productPagePartsPending[cacheKey].then(function (parts) {
        if (token !== mediaRefreshToken) return;
        applyProductPageParts(parts, material);
      });
    }

    function updateMaterialInfo(material) {
      var infoEl = root.querySelector('[data-kv-scb-material-info]');
      if (!infoEl) return;

      var titleEl = infoEl.querySelector('[data-kv-scb-material-info-title]');
      var textEl = infoEl.querySelector('[data-kv-scb-material-info-text]');
      var infoTitle = (material && material.infoTitle) || '';
      var infoText = (material && material.infoText) || '';

      if (!infoTitle && material && material.title) {
        infoTitle = material.title + ' selected';
      }

      if (titleEl) titleEl.textContent = infoTitle;
      if (textEl) {
        textEl.textContent = infoText;
        textEl.hidden = !infoText;
      }

      infoEl.hidden = !infoTitle && !infoText;
    }

    function switchMaterialProduct(nextProductId) {
      var material = materialsById[String(nextProductId)];
      if (!material) return;
      if (String(productId) === String(material.id)) return;

      try {
        variants = material.variants || [];
        colorOptions = (material.colors || []).map(function (c) { return c.value; });
        productId = String(material.id);
        productHandle = material.handle || '';

        root.dataset.productId = productId;
        root.dataset.productHandle = productHandle;
        root.dataset.defaultColor = material.defaultColor || '';

        var variantsEl = root.querySelector('script[data-kv-scb-variants]');
        if (variantsEl) {
          variantsEl.textContent = JSON.stringify(variants);
        }
        var colorsEl = root.querySelector('script[data-kv-scb-colors]');
        if (colorsEl) {
          colorsEl.textContent = JSON.stringify(colorOptions);
        }

        setActiveMaterialTab(productId);
        updateMaterialInfo(material);
        updateProductPageTitle(material.productTitle || material.title);
        refreshProductMediaAndTabs(material);
        rebuildColorGrid(material);
        rebuildModuleColorGrids(material);

        root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
          setCoverState(cover, 'idle');
          resetCoverToDefaults(cover);
        });

        var checked = root.querySelector('[data-kv-scb-global-color]:checked');
        if (checked) {
          handleColorSelection(checked);
        } else {
          refreshAll();
        }

        root.dispatchEvent(
          new CustomEvent('kv-scb:material-change', {
            bubbles: true,
            detail: { productId: productId, handle: productHandle }
          })
        );
      } catch (err) {
        if (window.console && console.error) {
          console.error('kv-scb material switch failed', err);
        }
      }
    }

    var shopCurrency = root.dataset.shopCurrency || '';
    var activeCurrency = root.dataset.currencyCode || shopCurrency || 'USD';
    var activeLocale = root.dataset.locale || document.documentElement.lang || '';

    var moneyFormatsByCurrency = {
      EUR: '€{{amount_with_comma_separator}}',
      USD: '${{amount}}',
      GBP: '£{{amount}}',
      CAD: '${{amount}}',
      AUD: '${{amount}}'
    };
    var atcBtn = root.querySelector('[data-kv-scb-atc]');
    var atcLabelEl = root.querySelector('.js-add-to-cart-text[data-kv-scb-atc-label]');
    var atcStatusEl = root.querySelector('[data-kv-scb-atc-status]');
    var atcPricesWrap = root.querySelector('[data-kv-scb-atc-prices]');
    var atcPriceEl = root.querySelector('[data-kv-scb-atc-price]');
    var atcCompareEl = root.querySelector('[data-kv-scb-atc-compare]');
    var formId = root.dataset.formId || '';
    var atcPromptLabel = root.dataset.atcPromptLabel || 'Select color & Quantity';
    var atcReadyLabel = root.dataset.atcReadyLabel || 'ADD TO CART';
    var atcAddingLabel = root.dataset.atcAddingLabel || 'ADDING...';
    var atcSoldOutLabel = root.dataset.atcSoldOutLabel || 'Out of stock';
    var klaviyoBisEnable = root.dataset.klaviyoBis === 'true';
    var klaviyoBisLabel = root.dataset.klaviyoBisLabel || 'Notify me when available';

    if (atcBtn) atcBtn.classList.add('kv-scb__btn--prompt');

    function applyIgPriceAttributes(el, variant, priceCents, isCompare) {
      if (!el || !variant) return;

      var variantId = String(variant.id);
      var productIdValue = String(variant.productId || productId || '');

      el.setAttribute('data-variant-id', variantId);
      el.setAttribute('data-price', String(priceCents));
      el.setAttribute('data-price-multiplier', '1');

      if (productIdValue) {
        el.setAttribute('data-product-id', productIdValue);
      }
    }

    function getGlobalColor() {
      var input = root.querySelector('[data-kv-scb-global-color]:checked');
      return input ? input.value : root.dataset.defaultColor || '';
    }

    function getModuleName(cover) {
      return (cover.dataset.moduleName || '').trim();
    }

    function normalizeSize(size) {
      return String(size || '').trim();
    }

    function moduleNamesMatch(a, b) {
      if (!a || !b) return false;
      a = String(a).trim();
      b = String(b).trim();
      return a === b || a.indexOf(b) !== -1 || b.indexOf(a) !== -1;
    }

    function buildVariantKey(moduleName, size, color) {
      return String(moduleName).trim() + ' ' + normalizeSize(size) + ' /' + String(color).trim();
    }

    function mapPvdEntry(entry, normModule, normSize, normColor) {
      return {
        id: Number(entry.id),
        productId: productId ? Number(productId) : null,
        available: !!entry.available,
        price: Number(entry.price) || 0,
        compare_at_price: Number(entry.compare_at_price) || 0,
        moduleName: normModule,
        size: normSize,
        options: [normSize, normColor].filter(Boolean),
        sku: entry.sku || ''
      };
    }

    function findVariantInProductVariantsData(normModule, normSize, normColor) {
      if (!productVariantsData || !normColor) return null;

      var exactKey = buildVariantKey(normModule, normSize, normColor);
      if (productVariantsData[exactKey]) {
        return mapPvdEntry(productVariantsData[exactKey], normModule, normSize, normColor);
      }

      var keys = Object.keys(productVariantsData);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var entry = productVariantsData[key];
        if (!key || !entry) continue;

        var slashIndex = key.lastIndexOf('/');
        if (slashIndex === -1) continue;

        var keyColor = key.substring(slashIndex + 1).trim();
        var beforeColor = key.substring(0, slashIndex).trim();

        if (keyColor !== normColor) continue;
        if (beforeColor.indexOf(normModule) === -1) continue;
        if (normSize && beforeColor.indexOf(normSize) === -1) continue;

        return mapPvdEntry(entry, normModule, normSize, normColor);
      }

      return null;
    }

    function mergeVariantAvailability(variant) {
      if (!variant || !variant.id || !productVariantsData) return variant;

      var keys = Object.keys(productVariantsData);
      for (var i = 0; i < keys.length; i++) {
        var entry = productVariantsData[keys[i]];
        if (entry && Number(entry.id) === Number(variant.id)) {
          return Object.assign({}, variant, { available: !!entry.available });
        }
      }

      return variant;
    }

    function findVariant(moduleName, color, size) {
      var normSize = normalizeSize(size);
      var normColor = String(color || '').trim();
      var normModule = String(moduleName || '').trim();

      if (!normModule) return null;

      var fromArray =
        variants.find(function (v) {
          if (!moduleNamesMatch(v.moduleName, normModule)) return false;
          if (normColor && v.options && v.options.indexOf(normColor) === -1) return false;
          if (normSize) {
            if (v.size && normalizeSize(v.size) === normSize) return true;
            if (v.options && v.options.indexOf(normSize) !== -1) return true;
            return false;
          }
          return true;
        }) || null;

      if (fromArray) {
        return mergeVariantAvailability(
          Object.assign({}, fromArray, {
            productId: fromArray.productId || (productId ? Number(productId) : null)
          })
        );
      }

      if (normColor) {
        return findVariantInProductVariantsData(normModule, normSize, normColor);
      }

      return null;
    }

    function getIgRawPrice(igPriceApi, variantId) {
      if (!igPriceApi) return null;

      var raw = null;
      if (typeof igPriceApi.getPriceByVariantId === 'function') {
        raw = igPriceApi.getPriceByVariantId(String(variantId));
      }
      if ((raw == null || raw === '') && typeof igPriceApi.getPriceByProductIdAndVariantId === 'function' && productId) {
        raw = igPriceApi.getPriceByProductIdAndVariantId(String(productId), String(variantId));
      }
      return raw;
    }

    function getIgRawComparePrice(igPriceApi, variantId) {
      if (!igPriceApi) return null;

      var raw = null;
      if (typeof igPriceApi.getComparePriceByVariantId === 'function') {
        raw = igPriceApi.getComparePriceByVariantId(String(variantId));
      }
      if ((raw == null || raw === '') && typeof igPriceApi.getComparePriceByProductIdAndVariantId === 'function' && productId) {
        raw = igPriceApi.getComparePriceByProductIdAndVariantId(String(productId), String(variantId));
      }
      return raw;
    }

    function parseIgMoneyToCents(raw, fallbackCents) {
      if (raw == null || raw === '') return fallbackCents;
      if (typeof raw === 'number' && Number.isFinite(raw)) {
        return Number.isInteger(raw) && raw >= 100 ? raw : Math.round(raw * 100);
      }

      var normalized = String(raw).trim();
      if (!normalized) return fallbackCents;

      var digits = normalized.replace(/[^0-9.]/g, '');
      if (!digits) return fallbackCents;

      var dollars = parseFloat(digits);
      return Number.isFinite(dollars) ? Math.round(dollars * 100) : fallbackCents;
    }

    function igPriceCents(variantId, fallback) {
      var igPriceApi = window.igData && window.igData.price;
      return parseIgMoneyToCents(getIgRawPrice(igPriceApi, variantId), fallback);
    }

    function igCompareCents(variantId, fallback) {
      var igPriceApi = window.igData && window.igData.price;
      return parseIgMoneyToCents(getIgRawComparePrice(igPriceApi, variantId), fallback);
    }

    function getActiveCurrency() {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return Shopify.currency.active;
      }
      return activeCurrency || shopCurrency || 'USD';
    }

    function moneyFormatMatchesCurrency(format, currency) {
      if (!format || !currency) return false;
      if (currency === 'EUR') return format.indexOf('€') !== -1;
      if (currency === 'GBP') return format.indexOf('£') !== -1;
      if (currency === 'USD' || currency === 'CAD' || currency === 'AUD') {
        return format.indexOf('$') !== -1 || format.indexOf(currency) !== -1;
      }
      return true;
    }

    function getMoneyFormat() {
      var currency = getActiveCurrency();
      var themeFormat =
        (window.Shopify && Shopify.currency && Shopify.currency.money_format) ||
        (window.theme && theme.moneyFormat) ||
        '';

      if (themeFormat && moneyFormatMatchesCurrency(themeFormat, currency)) {
        return themeFormat;
      }

      if (moneyFormatsByCurrency[currency]) {
        return moneyFormatsByCurrency[currency];
      }

      return '${{amount}}';
    }

    function getFormatLocale() {
      var currency = getActiveCurrency();
      var locale = activeLocale || document.documentElement.lang || '';

      if (currency === 'EUR') {
        if (!locale || locale.indexOf('en') === 0) return 'de-DE';
        return locale;
      }

      return locale || undefined;
    }

    function formatMoney(cents) {
      var format = getMoneyFormat();

      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format);
      }

      var amount = cents / 100;
      var currency = getActiveCurrency();

      try {
        return new Intl.NumberFormat(getFormatLocale(), {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (e) {}

      return String(amount);
    }

    function syncCurrencyContext(nextCurrency) {
      if (!nextCurrency) return;
      activeCurrency = nextCurrency;
      root.dataset.currencyCode = nextCurrency;
    }

    function syncCurrencyFromCart() {
      var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var baseUrl = cartRoot.replace(/\/?$/, '/');

      return fetch(baseUrl + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (cart && cart.currency) {
            syncCurrencyContext(cart.currency);
          }
        })
        .catch(function () {});
    }

    function applyProductVariantPricing(product) {
      if (!product || !product.variants || !product.variants.length) return;

      var priceById = {};

      product.variants.forEach(function (variant) {
        if (!variant || !variant.id) return;
        priceById[String(variant.id)] = {
          price: Number(variant.price) || 0,
          compare_at_price: Number(variant.compare_at_price) || 0,
          available: variant.available
        };
      });

      variants.forEach(function (variant) {
        var updated = priceById[String(variant.id)];
        if (!updated) return;
        variant.price = updated.price;
        variant.compare_at_price = updated.compare_at_price;
        variant.available = updated.available;
      });

      if (productVariantsData) {
        Object.keys(productVariantsData).forEach(function (key) {
          var entry = productVariantsData[key];
          if (!entry || !entry.id) return;
          var updated = priceById[String(entry.id)];
          if (!updated) return;
          entry.price = updated.price;
          entry.compare_at_price = updated.compare_at_price;
          entry.available = updated.available;
        });
      }
    }

    function refreshVariantPricesForMarket() {
      if (!productHandle) return syncCurrencyFromCart().then(function () { refreshAll(); });

      var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var baseUrl = cartRoot.replace(/\/?$/, '/');

      return Promise.all([
        fetch(baseUrl + 'products/' + encodeURIComponent(productHandle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          return response.json();
        }),
        fetch(baseUrl + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          return response.json();
        })
      ])
        .then(function (results) {
          var product = results[0];
          var cart = results[1];

          if (cart && cart.currency) {
            syncCurrencyContext(cart.currency);
          }

          applyProductVariantPricing(product);
          refreshAll();
        })
        .catch(function () {});
    }

    function bindMarketPriceRefresh() {
      if (root.dataset.kvScbMarketBound === 'true') return;
      root.dataset.kvScbMarketBound = 'true';

      var marketEvents = [
        'currency:changed',
        'localization:changed',
        'market:changed',
        'shopify:localization:changed',
        'country:changed'
      ];

      marketEvents.forEach(function (eventName) {
        document.addEventListener(eventName, refreshVariantPricesForMarket);
        window.addEventListener(eventName, refreshVariantPricesForMarket);
      });

      if (window.EventBus && typeof window.EventBus.on === 'function') {
        marketEvents.forEach(function (eventName) {
          window.EventBus.on(eventName, refreshVariantPricesForMarket);
        });
      }

      document.addEventListener('change', function (event) {
        var target = event.target;
        if (!target) return;

        if (
          target.matches('[name="country_code"], [name="locale_code"], [name="currency_code"]') ||
          target.closest('form[action*="/localization"]')
        ) {
          window.setTimeout(refreshVariantPricesForMarket, 300);
        }
      });

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (form && form.matches && form.matches('form[action*="/localization"]')) {
          window.setTimeout(refreshVariantPricesForMarket, 500);
        }
      });
    }

    function setAtcMoneyDisplay(el, cents) {
      if (!el || !Number.isFinite(cents)) return;

      el.setAttribute('data-price', String(cents));
      el.textContent = formatMoney(cents);
    }

    function refreshIgCoverPrices() {
      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (!cover.classList.contains('kv-scb__cover--idle')) {
          refreshCoverPrice(cover);
        }
      });

      if (typeof window.fmRefreshIgAtcPrices === 'function') {
        window.fmRefreshIgAtcPrices(null, formatMoney);
      }
    }

    function sumSelectedCoverTotals() {
      var totalPrice = 0;
      var totalCompare = 0;
      var hasCompare = false;

      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (cover.classList.contains('kv-scb__cover--idle')) return;

        var selection = getCoverSelection(cover);
        var hasSizeOptions = !!cover.querySelector('[data-kv-scb-size]');
        if (hasSizeOptions && !selection.size) return;
        if (!selection.color) return;

        var variant = findVariant(selection.moduleName, selection.color, selection.size);
        if (!variant || !variant.id) return;

        var qty = selection.qty || 1;
        var fallbackPrice = Number(variant.price) || 0;
        var fallbackCompare = Number(variant.compare_at_price) || 0;
        var priceCents = igPriceCents(variant.id, fallbackPrice);
        var compareCents = igCompareCents(variant.id, fallbackCompare);

        totalPrice += priceCents * qty;
        if (compareCents > priceCents) {
          hasCompare = true;
          totalCompare += compareCents * qty;
        } else {
          totalCompare += priceCents * qty;
        }
      });

      return { totalPrice: totalPrice, totalCompare: totalCompare, hasCompare: hasCompare };
    }

    function updateAtcPriceDisplay(totals, show) {
      if (!atcPricesWrap) return;

      if (!show || !totals || totals.totalPrice <= 0) {
        atcPricesWrap.hidden = true;
        return;
      }

      atcPricesWrap.hidden = false;

      if (atcPriceEl) {
        atcPriceEl.hidden = false;
        atcPriceEl.removeAttribute('aria-hidden');
        setAtcMoneyDisplay(atcPriceEl, totals.totalPrice);
        atcPriceEl.classList.toggle('kv-price-on-sale', totals.hasCompare);
      }

      if (atcCompareEl) {
        if (totals.hasCompare) {
          setAtcMoneyDisplay(atcCompareEl, totals.totalCompare);
          atcCompareEl.hidden = false;
          atcCompareEl.removeAttribute('hidden');
          atcCompareEl.classList.remove('hide');
          atcCompareEl.setAttribute('aria-hidden', 'false');
        } else {
          atcCompareEl.textContent = '';
          atcCompareEl.hidden = true;
          atcCompareEl.setAttribute('hidden', '');
          atcCompareEl.classList.add('hide');
          atcCompareEl.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function getCoverSelection(cover) {
      var moduleName = getModuleName(cover);
      var sizeInput = cover.querySelector('[data-kv-scb-size]:checked');
      var size = sizeInput ? sizeInput.value : '';
      var moduleColorInput = cover.querySelector('[data-kv-scb-module-color]:checked');
      var color = moduleColorInput
        ? moduleColorInput.value
        : cover.dataset.kvScbIntendedColor || getGlobalColor();
      var qtyInput =
        cover.querySelector('[data-kv-scb-header-qty]:not([hidden]) [data-kv-scb-qty]') ||
        cover.querySelector('[data-kv-scb-panel-qty] [data-kv-scb-qty]') ||
        cover.querySelector('[data-kv-scb-qty]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      return { moduleName: moduleName, color: color, size: size, qty: qty };
    }

    function applyPriceElements(priceEl, compareEl, variant, priceWrap) {
      if (!variant || !priceEl) return;

      var priceCents = igPriceCents(variant.id, Number(variant.price) || 0);
      var compareCents = igCompareCents(variant.id, Number(variant.compare_at_price) || 0);
      var onSale = compareCents > priceCents;

      priceEl.textContent = formatMoney(priceCents);
      applyIgPriceAttributes(priceEl, variant, priceCents, false);
      priceEl.classList.toggle('price-on-sale', onSale);

      if (priceWrap) {
        priceWrap.setAttribute('data-variant-id', String(variant.id));
        if (productId) priceWrap.setAttribute('data-product-id', String(productId));
      }

      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(compareCents);
          applyIgPriceAttributes(compareEl, variant, compareCents, true);
          compareEl.classList.remove('hide');
          compareEl.hidden = false;
          compareEl.setAttribute('aria-hidden', 'false');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('hide');
          compareEl.hidden = true;
          compareEl.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function getSwatchStyleForColor(colorValue, cover) {
      if (!colorValue) return '';

      var escaped = colorValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      var input =
        root.querySelector('[data-kv-scb-global-color][value="' + escaped + '"]') ||
        (cover && cover.querySelector('[data-kv-scb-module-color][value="' + escaped + '"]'));

      if (!input || !input.id) return '';

      var inner = document.querySelector('label[for="' + input.id + '"] .kv-scb__color-swatch-inner:not(.kv-for-color-bg-swatch)');
      return inner ? inner.getAttribute('style') || '' : '';
    }

    function getDefaultColor() {
      return root.dataset.defaultColor || getGlobalColor() || '';
    }

    function resetCoverToDefaults(cover) {
      if (!cover) return;

      var defaultColor = getGlobalColor() || getDefaultColor();

      cover.dataset.kvScbIntendedColor = defaultColor;
      cover.classList.remove('kv-scb__cover--panel-open');

      var panel = cover.querySelector('[data-kv-scb-panel]');
      if (panel) panel.hidden = true;

      setSwatchesVisible(cover, false);

      var sizeInputs = cover.querySelectorAll('[data-kv-scb-size]');
      if (sizeInputs.length) {
        sizeInputs.forEach(function (input, index) {
          input.checked = index === 0;
        });
        updatePanelSizes(cover);
      }

      setCoverModuleColor(cover, defaultColor);

      cover.querySelectorAll('[data-kv-scb-qty]').forEach(function (input) {
        input.value = '1';
      });

      updateModuleColorAvailability(cover);
      updatePanelColorLabel(cover, defaultColor);
      refreshCoverPrice(cover);
    }

    function updateCoverSummary(cover) {
      if (!cover) return;

      var selection = getCoverSelection(cover);
      var sizeEl = cover.querySelector('[data-kv-scb-summary-size]');
      var sizeLine = cover.querySelector('[data-kv-scb-cover-size-line]');
      var swatchEl = cover.querySelector('[data-kv-scb-summary-swatch]');
      var colorLabel = cover.querySelector('[data-kv-scb-chosen-color-label]');
      var hasSize = !!cover.querySelector('[data-kv-scb-size]');

      if (sizeEl) sizeEl.textContent = selection.size || '';
      if (sizeLine) sizeLine.hidden = !hasSize || !selection.size;
      if (colorLabel) colorLabel.textContent = selection.color || '';

      if (swatchEl) {
        var style = getSwatchStyleForColor(selection.color, cover);
        if (style) {
          swatchEl.setAttribute('style', style);
          swatchEl.hidden = false;
          swatchEl.setAttribute('aria-hidden', 'false');
        } else {
          swatchEl.removeAttribute('style');
          swatchEl.hidden = true;
          swatchEl.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function setCoverState(cover, state) {
      cover.classList.remove('kv-scb__cover--idle', 'kv-scb__cover--editing', 'kv-scb__cover--confirmed');
      cover.classList.add('kv-scb__cover--' + state);

      var panel = cover.querySelector('[data-kv-scb-panel]');
      var addBtn = cover.querySelector('[data-kv-scb-add]');
      var cancelBtn = cover.querySelector('[data-kv-scb-cancel]');
      var changeBtn = cover.querySelector('[data-kv-scb-change]');
      var variantsBlock = cover.querySelector('[data-kv-scb-variants]');
      var headerQty = cover.querySelector('[data-kv-scb-header-qty]');

      if (state === 'editing') {
        if (panel) panel.hidden = false;
        if (addBtn) addBtn.hidden = true;
        if (cancelBtn) cancelBtn.hidden = false;
        if (changeBtn) changeBtn.hidden = true;
        if (variantsBlock) variantsBlock.hidden = true;
        if (headerQty) headerQty.hidden = true;
        setSwatchesVisible(cover, false);
        updatePanelColorLabel(cover);
        updateModuleColorAvailability(cover);
      } else if (state === 'confirmed') {
        if (panel) panel.hidden = true;
        if (addBtn) addBtn.hidden = true;
        if (cancelBtn) cancelBtn.hidden = true;
        if (changeBtn) changeBtn.hidden = false;
        if (variantsBlock) variantsBlock.hidden = false;
        if (headerQty) headerQty.hidden = false;
        cover.classList.remove('kv-scb__cover--panel-open');
        updateCoverSummary(cover);
      } else {
        if (panel) panel.hidden = true;
        if (addBtn) addBtn.hidden = false;
        if (cancelBtn) cancelBtn.hidden = true;
        if (changeBtn) changeBtn.hidden = true;
        if (variantsBlock) variantsBlock.hidden = true;
        if (headerQty) headerQty.hidden = true;
        cover.classList.remove('kv-scb__cover--panel-open');
      }

      refreshCoverPrice(cover);
    }

    function updatePanelColorLabel(cover, colorOverride) {
      var label = cover.querySelector('[data-kv-scb-panel-color-label]');
      if (!label) return;

      if (colorOverride != null && colorOverride !== '') {
        label.textContent = colorOverride;
        return;
      }

      var selection = getCoverSelection(cover);
      label.textContent = selection.color || getGlobalColor();
    }

    function syncPanelColorFromInput(cover, colorInput) {
      if (!cover || !colorInput || !colorInput.matches('[data-kv-scb-module-color]')) return;

      updatePanelColorLabel(cover, colorInput.value);
      updatePanelSwatches(cover);
      refreshCoverPrice(cover);
    }

    function setCoverModuleColor(cover, colorValue) {
      if (!cover || !colorValue) return;

      cover.dataset.kvScbIntendedColor = colorValue;

      var inputs = cover.querySelectorAll('[data-kv-scb-module-color]');
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
      }

      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === colorValue) {
          inputs[j].checked = true;
          break;
        }
      }
    }

    function applyGlobalColorToCovers(globalColor) {
      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (cover.classList.contains('kv-scb__cover--confirmed')) {
          return;
        }

        setCoverModuleColor(cover, globalColor);
        updateModuleColorAvailability(cover);
        updatePanelColorLabel(cover, globalColor);

        if (!cover.classList.contains('kv-scb__cover--idle')) {
          updateCoverSummary(cover);
        }

        refreshCoverPrice(cover);
      });
    }

    function setSwatchesVisible(cover, visible) {
      var swatches = cover.querySelector('[data-kv-scb-module-colors]');
      var toggleBtn = cover.querySelector('[data-kv-scb-toggle-swatches]');
      var hideText = cover.querySelector('[data-kv-scb-toggle-text-hide]');
      var showText = cover.querySelector('[data-kv-scb-toggle-text-show]');

      if (swatches) swatches.hidden = !visible;
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', visible ? 'true' : 'false');
      if (hideText) hideText.hidden = !visible;
      if (showText) showText.hidden = visible;
    }

    function syncModuleColorFromGlobal(cover) {
      if (cover.querySelector('[data-kv-scb-module-color]:checked')) return;

      var colorToApply = cover.dataset.kvScbIntendedColor || getGlobalColor();
      setCoverModuleColor(cover, colorToApply);
    }

    function updateModuleColorAvailability(cover) {
      var moduleName = getModuleName(cover);
      var sizeInput = cover.querySelector('[data-kv-scb-size]:checked');
      var sizeVal = sizeInput ? sizeInput.value : '';
      var intendedColor = cover.dataset.kvScbIntendedColor || getGlobalColor();

      cover.querySelectorAll('[data-kv-scb-color-item]').forEach(function (item) {
        var input = item.querySelector('[data-kv-scb-module-color]');
        if (!input) return;

        var color = input.value;
        var variant = findVariant(moduleName, color, sizeVal);
        var available = !!(variant && variant.available);

        item.classList.toggle('kv-scb__color-item--unavailable', !available);
        input.removeAttribute('disabled');

        if (available) {
          input.removeAttribute('aria-disabled');
        } else {
          input.setAttribute('aria-disabled', 'true');
        }
      });

      if (intendedColor) {
        setCoverModuleColor(cover, intendedColor);
      } else {
        syncModuleColorFromGlobal(cover);
      }

      updatePanelSwatches(cover);
      updatePanelSizes(cover);
      updatePanelColorLabel(cover, intendedColor);
      refreshCoverPrice(cover);
    }

    function updatePanelSwatches(scope) {
      var grid = scope.querySelector('.kv-scb__module-color-grid');
      if (!grid) return;

      grid.querySelectorAll('.kv-scb__color-swatch').forEach(function (label) {
        label.classList.remove('kv-scb__color-swatch--selected');
      });
      grid.querySelectorAll('[data-kv-scb-module-color]:checked').forEach(function (input) {
        var label = scope.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-scb__color-swatch--selected');
      });
    }

    function updatePanelSizes(scope) {
      var sizeList = scope.querySelector('.kv-scb__size-list');
      if (!sizeList) return;

      sizeList.querySelectorAll('.kv-scb__size-btn').forEach(function (label) {
        label.classList.remove('kv-scb__size-btn--selected');
      });
      sizeList.querySelectorAll('[data-kv-scb-size]:checked').forEach(function (input) {
        var label = scope.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.add('kv-scb__size-btn--selected');
      });

      updateSizePromoLabels(scope);
    }

    function updateSizePromoLabels(cover) {
      if (!cover) return;

      var sizeList = cover.querySelector('.kv-scb__size-list');
      if (!sizeList) return;

      var moduleColorInput = cover.querySelector('[data-kv-scb-module-color]:checked');
      var color = String(
        cover.dataset.kvScbIntendedColor ||
          (moduleColorInput && moduleColorInput.value) ||
          getGlobalColor() ||
          ''
      ).trim();

      sizeList.querySelectorAll('[data-kv-scb-size]').forEach(function (input) {
        var item = input.closest('.kv-scb__size-item');
        var label = item ? item.querySelector('.kv-scb__size-btn') : null;
        if (!label) return;

        var sizeLabelEl = label.querySelector('.kv-scb__size-label');
        var promoEl = label.querySelector('.kv-scb__size-promo');
        var promos = {};
        var promoText = '';

        try {
          promos = JSON.parse(input.getAttribute('data-kv-scb-size-promos') || '{}') || {};
        } catch (err) {
          promos = {};
        }

        if (color && promos[color]) {
          promoText = String(promos[color]);
        } else if (color) {
          Object.keys(promos).forEach(function (key) {
            if (!promoText && String(key).trim() === color) {
              promoText = String(promos[key] || '');
            }
          });
        }

        if (promoText) {
          if (!promoEl) {
            promoEl = document.createElement('span');
            promoEl.className = 'kv-scb__size-promo';
            label.appendChild(promoEl);
          }
          promoEl.textContent = promoText;
          promoEl.removeAttribute('hidden');
          if (item) item.classList.add('kv-scb__size-item--promo');
          label.classList.add('kv-scb__size-btn--promo');
          if (sizeLabelEl) sizeLabelEl.classList.add('kv-scb__size-label--promo');
        } else {
          if (promoEl) {
            promoEl.textContent = '';
            promoEl.setAttribute('hidden', '');
          }
          if (item) item.classList.remove('kv-scb__size-item--promo');
          label.classList.remove('kv-scb__size-btn--promo');
          if (sizeLabelEl) sizeLabelEl.classList.remove('kv-scb__size-label--promo');
        }
      });
    }

    function updateSelectedSwatches(scope) {
      if (scope.matches && scope.matches('[data-kv-scb]')) {
        scope.querySelectorAll('.kv-scb__color-swatch').forEach(function (label) {
          label.classList.remove('kv-scb__color-swatch--selected');
        });
        scope.querySelectorAll('[data-kv-scb-global-color]:checked').forEach(function (input) {
          var label = scope.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.add('kv-scb__color-swatch--selected');
        });
        return;
      }

      updatePanelSwatches(scope);
      updatePanelSizes(scope);
    }

    function updatePanelUpdateButton(cover) {
      var updateBtn = cover.querySelector('[data-kv-scb-update]');
      if (!updateBtn) return;

      var selection = getCoverSelection(cover);
      var variant = findVariant(selection.moduleName, selection.color, selection.size);
      var canUpdate = !!(variant && isVariantInStock(variant));

      updateBtn.disabled = !canUpdate;
      updateBtn.classList.toggle('is-disabled', !canUpdate);
      updateBtn.setAttribute('aria-disabled', canUpdate ? 'false' : 'true');
    }

    function refreshCoverPrice(cover) {
      var selection = getCoverSelection(cover);
      var variant = findVariant(selection.moduleName, selection.color, selection.size);
      var priceWrap = cover.querySelector('[data-kv-scb-cover-price]');
      if (!priceWrap) {
        updatePanelUpdateButton(cover);
        return;
      }

      if (!variant) {
        priceWrap.hidden = true;
        updatePanelUpdateButton(cover);
        return;
      }

      applyPriceElements(
        cover.querySelector('[data-kv-scb-price]'),
        cover.querySelector('[data-kv-scb-compare]'),
        variant,
        priceWrap
      );
      priceWrap.hidden = false;
      updatePanelUpdateButton(cover);
    }

    function isVariantInStock(variant) {
      if (!variant || !variant.id) return false;
      if (variant.available === false || variant.available === 'false') return false;
      if (variant.available === true || variant.available === 'true') return true;

      if (productVariantsData) {
        var keys = Object.keys(productVariantsData);
        for (var i = 0; i < keys.length; i++) {
          var entry = productVariantsData[keys[i]];
          if (entry && Number(entry.id) === Number(variant.id)) {
            return entry.available !== false && entry.available !== 'false';
          }
        }
      }

      return variant.available !== false && variant.available !== 'false';
    }

    function collectLineItems() {
      var items = [];

      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (!cover.classList.contains('kv-scb__cover--confirmed')) return;

        var item = buildLineItemFromCover(cover);
        if (item) items.push(item);
      });

      return items;
    }

    function collectBundleLineItems() {
      var items = [];

      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (cover.classList.contains('kv-scb__cover--idle')) return;

        var item = buildLineItemFromCover(cover);
        if (item) items.push(item);
      });

      return items;
    }

    function mergeLineItemsForCart(items) {
      var merged = [];
      var indexById = {};

      items.forEach(function (item) {
        var key = String(item.id);
        if (indexById[key] == null) {
          indexById[key] = merged.length;
          merged.push({
            id: item.id,
            quantity: item.quantity,
            available: item.available,
            priceCents: item.priceCents,
            compareCents: item.compareCents,
            moduleName: item.moduleName,
            sku: item.sku
          });
          return;
        }

        merged[indexById[key]].quantity += item.quantity;
      });

      return merged;
    }

    function hasEngagedCover() {
      return !!root.querySelector(
        '.kv-scb__cover--editing, .kv-scb__cover--confirmed, .kv-scb__cover--panel-open'
      );
    }

    function getActiveCoverForCart() {
      return (
        root.querySelector('.kv-scb__cover--editing.kv-scb__cover--panel-open') ||
        root.querySelector('.kv-scb__cover--editing') ||
        root.querySelector('.kv-scb__cover--confirmed') ||
        null
      );
    }

    function buildLineItemFromCover(cover) {
      if (!cover) return null;

      var selection = getCoverSelection(cover);
      var hasSizeOptions = !!cover.querySelector('[data-kv-scb-size]');
      if (hasSizeOptions && !selection.size) return null;
      if (!selection.color) return null;

      var variant = findVariant(selection.moduleName, selection.color, selection.size);
      if (!variant || !variant.id) return null;

      var priceCents = igPriceCents(variant.id, Number(variant.price) || 0);
      var compareCents = igCompareCents(variant.id, Number(variant.compare_at_price) || 0);

      return {
        id: variant.id,
        quantity: selection.qty,
        available: isVariantInStock(variant),
        priceCents: priceCents,
        compareCents: compareCents,
        moduleName: selection.moduleName,
        sku: variant.sku || ''
      };
    }

    function collectLineItemsForCart() {
      return mergeLineItemsForCart(collectBundleLineItems());
    }

    function hasConfirmedUnavailableSelection() {
      var hasConfirmed = false;
      var hasUnavailable = false;

      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (!cover.classList.contains('kv-scb__cover--confirmed')) return;

        var selection = getCoverSelection(cover);
        var hasSizeOptions = !!cover.querySelector('[data-kv-scb-size]');
        if (hasSizeOptions && !selection.size) return;
        if (!selection.color) return;

        hasConfirmed = true;
        if (!isVariantInStock(findVariant(selection.moduleName, selection.color, selection.size))) {
          hasUnavailable = true;
        }
      });

      return hasConfirmed && hasUnavailable;
    }

    function getSoldOutLeadVariantId(items) {
      if (items.length) {
        var unavailable = null;
        items.forEach(function (item) {
          if (!item.available && !unavailable) unavailable = item;
        });
        return (unavailable || items[0]).id;
      }

      var variantId = null;
      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        if (variantId) return;
        if (!cover.classList.contains('kv-scb__cover--confirmed')) return;

        var selection = getCoverSelection(cover);
        var hasSizeOptions = !!cover.querySelector('[data-kv-scb-size]');
        if (hasSizeOptions && !selection.size) return;
        if (!selection.color) return;

        var variant = findVariant(selection.moduleName, selection.color, selection.size);
        if (variant && variant.id) variantId = variant.id;
      });

      return variantId;
    }

    function hasConfirmedCovers() {
      return !!root.querySelector('.kv-scb__cover--confirmed');
    }

    function getUrlVariantId() {
      try {
        var value = new URL(window.location.href).searchParams.get('variant');
        return value ? String(value) : null;
      } catch (e) {
        return null;
      }
    }

    function syncBundleUrlVariant(variantId) {
      if (!variantId) return;

      var nextVariantId = String(variantId);
      if (getUrlVariantId() === nextVariantId) return;

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', nextVariantId);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {}

      document.dispatchEvent(
        new CustomEvent('kv-scb:variant-change', {
          bubbles: true,
          detail: { variantId: nextVariantId, productId: productId || null }
        })
      );
    }

    function findVariantById(variantId) {
      if (!variantId) return null;

      var id = Number(variantId);
      var fromArray = variants.find(function (v) {
        return Number(v.id) === id;
      });
      if (fromArray) return fromArray;

      if (!productVariantsData) return null;

      var keys = Object.keys(productVariantsData);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var entry = productVariantsData[key];
        if (!entry || Number(entry.id) !== id) continue;

        return {
          id: id,
          available: !!entry.available,
          price: Number(entry.price) || 0,
          compare_at_price: Number(entry.compare_at_price) || 0,
          title: key,
          moduleName: key,
          options: []
        };
      }

      return null;
    }

    function resolveVariantFromCover(cover) {
      if (!cover) return null;

      var selection = getCoverSelection(cover);
      var hasSizeOptions = !!cover.querySelector('[data-kv-scb-size]');
      if (!selection.color) return null;
      if (hasSizeOptions && !selection.size) return null;

      return findVariant(selection.moduleName, selection.color, selection.size);
    }

    function getLeadSelectionVariant() {
      if (!hasEngagedCover()) return null;

      var prioritySelectors = [
        '.kv-scb__cover--editing.kv-scb__cover--panel-open',
        '.kv-scb__cover--editing',
        '.kv-scb__cover--confirmed'
      ];
      var i;

      for (i = 0; i < prioritySelectors.length; i++) {
        var prioritizedCover = root.querySelector(prioritySelectors[i]);
        var prioritizedVariant = resolveVariantFromCover(prioritizedCover);
        if (prioritizedVariant) return prioritizedVariant;
      }

      return null;
    }

    function handleColorSelection(colorInput) {
      if (!colorInput) return;

      if (colorInput.matches('[data-kv-scb-global-color]')) {
        updateSelectedSwatches(root);
        filterGallery();
        applyGlobalColorToCovers(colorInput.value);
        root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
          updateModuleColorAvailability(cover);
          updateSizePromoLabels(cover);
          refreshCoverPrice(cover);
        });
        updateAtcTotals();
        return;
      }

      if (colorInput.matches('[data-kv-scb-module-color]')) {
        var moduleCover = colorInput.closest('[data-kv-scb-cover]');
        if (!moduleCover) return;

        moduleCover.dataset.kvScbIntendedColor = colorInput.value;
        updatePanelColorLabel(moduleCover, colorInput.value);
        updatePanelSwatches(moduleCover);
        updateModuleColorAvailability(moduleCover);
        updateSizePromoLabels(moduleCover);
        refreshCoverPrice(moduleCover);

        if (moduleCover.classList.contains('kv-scb__cover--confirmed')) {
          updateCoverSummary(moduleCover);
        }

        updateAtcTotals();
      }
    }

    function handleSizeSelection(sizeInput) {
      if (!sizeInput) return;

      var coverEl = sizeInput.closest('[data-kv-scb-cover]');
      if (!coverEl) return;

      updateModuleColorAvailability(coverEl);
      updatePanelSizes(coverEl);
      refreshCoverPrice(coverEl);

      if (coverEl.classList.contains('kv-scb__cover--confirmed')) {
        updateCoverSummary(coverEl);
      }

      updateAtcTotals();
    }

    function updateSelectionPreview(variant) {
      var previewEl = root.querySelector('[data-kv-scb-selection-preview]');
      if (!previewEl) return;

      if (!variant || !variant.id) {
        previewEl.hidden = true;
        previewEl.textContent = '';
        root.removeAttribute('data-active-variant-id');
        return;
      }

      var label = variant.title || variant.moduleName || '';
      var stockLabel = isVariantInStock(variant) ? 'In stock' : 'Out of stock';
      previewEl.textContent = label ? label + ' — ' + stockLabel : stockLabel;
      previewEl.hidden = false;
      root.setAttribute('data-active-variant-id', String(variant.id));
    }

    function detachProductFormVariantForPrompt() {
      var idInput = getProductFormIdInput();
      if (!idInput) return;

      if (!idInput.getAttribute('data-kv-scb-id-detached')) {
        if (idInput.value) {
          idInput.setAttribute('data-kv-scb-stored-variant', idInput.value);
        }
        idInput.removeAttribute('name');
        idInput.setAttribute('data-kv-scb-id-detached', '');
      }

      idInput.value = '';

      var syncInput = root.querySelector('[data-kv-scb-variant-id-sync]');
      if (syncInput) {
        syncInput.value = '';
        syncInput.removeAttribute('name');
      }
    }

    function clearBundleSelectionVariant() {
      updateSelectionPreview(null);
      root.removeAttribute('data-active-variant-id');
      detachProductFormVariantForPrompt();
    }

    function syncBundleSelectionVariant(variant) {
      if (!variant || !variant.id || !hasEngagedCover()) {
        clearBundleSelectionVariant();
        return;
      }

      syncBundleUrlVariant(variant.id);
      syncProductFormVariantId(variant.id);
      updateSelectionPreview(variant);
    }

    function getProductFormIdInput() {
      var form = formId ? document.getElementById(formId) : null;
      if (!form) return null;

      return (
        form.querySelector('input[name="id"]') ||
        form.querySelector('input[data-kv-scb-id-detached]')
      );
    }

    function syncProductFormVariantId(variantId) {
      if (!variantId) return;

      var value = String(variantId);
      var idInput = getProductFormIdInput();

      if (idInput) {
        idInput.setAttribute('name', 'id');
        idInput.removeAttribute('data-kv-scb-id-detached');
        idInput.value = value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      if (!formId) return;

      var syncInput = root.querySelector('[data-kv-scb-variant-id-sync]');
      if (!syncInput) {
        syncInput = document.createElement('input');
        syncInput.type = 'hidden';
        syncInput.setAttribute('data-kv-scb-variant-id-sync', '');
        syncInput.setAttribute('form', formId);
        root.appendChild(syncInput);
      }

      syncInput.setAttribute('name', 'id');
      syncInput.value = value;
      syncInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function setAtcStatusText(text) {
      if (atcStatusEl && text) atcStatusEl.textContent = text;
    }

    function setAtcAddingState(isAdding) {
      if (!atcBtn) return;

      atcBtn.classList.toggle('is-adding', isAdding);

      if (!isAdding) {
        if (atcPriceEl) {
          atcPriceEl.hidden = false;
          atcPriceEl.removeAttribute('aria-hidden');
        }
        return;
      }

      if (atcLabelEl) atcLabelEl.textContent = atcAddingLabel;
      setAtcStatusText(atcAddingLabel);
      if (atcPricesWrap) atcPricesWrap.hidden = true;
      if (atcCompareEl) {
        atcCompareEl.hidden = true;
        atcCompareEl.classList.add('hide');
        atcCompareEl.setAttribute('aria-hidden', 'true');
      }
      if (atcPriceEl) atcPriceEl.hidden = true;
      atcBtn.disabled = true;
    }

    function setAtcIntegrationMode(mode) {
      if (!atcBtn) return;

      atcBtn.setAttribute('data-kv-scb-atc-mode', mode);
      atcBtn.classList.remove('add-to-cart-button', 'klaviyo-bis-trigger');
      atcBtn.removeAttribute('data-klaviyo-bis-button-text');
      atcBtn.removeAttribute('aria-label');

      if (mode === 'ready' || mode === 'klaviyo') {
        atcBtn.classList.add('add-to-cart-button');
      }

      if (mode === 'klaviyo') {
        atcBtn.classList.add('klaviyo-bis-trigger');
        atcBtn.setAttribute('data-klaviyo-bis-button-text', klaviyoBisLabel);
      }
    }

    function setAtcKlaviyoMode(isKlaviyo, variantId) {
      if (!atcBtn) return;

      if (isKlaviyo && variantId) {
        var notifyVariantId = String(variantId);

        setAtcIntegrationMode('klaviyo');
        atcBtn.classList.remove('is-disabled');
        atcBtn.disabled = false;
        if (atcLabelEl) atcLabelEl.textContent = klaviyoBisLabel;
        setAtcStatusText(klaviyoBisLabel);
        syncBundleSelectionVariant(
          findVariantById(notifyVariantId) || { id: Number(notifyVariantId), title: '', available: false }
        );
        if (atcPriceEl) atcPriceEl.setAttribute('data-variant-id', notifyVariantId);
        return;
      }

      setAtcIntegrationMode('prompt');
    }

    function getUnavailableVariantId(items, leadVariant) {
      var item;

      for (var i = 0; i < items.length; i++) {
        if (!items[i].available) return items[i].id;
      }

      if (leadVariant && leadVariant.id && !isVariantInStock(leadVariant)) {
        return leadVariant.id;
      }

      return getSoldOutLeadVariantId(items);
    }

    function updateAtcTotals() {
      var items = collectBundleLineItems();
      var leadVariant = getLeadSelectionVariant();
      var confirmedOos = hasConfirmedUnavailableSelection();
      var cartHasOos = items.some(function (item) {
        return !item.available;
      });
      var cartUnavailable = confirmedOos || cartHasOos;
      var previewUnavailable =
        hasEngagedCover() &&
        items.length === 0 &&
        !!(leadVariant && leadVariant.id && !isVariantInStock(leadVariant));
      var isUnavailable = cartUnavailable || previewUnavailable;

      if (hasEngagedCover() && leadVariant && leadVariant.id && items.length <= 1) {
        syncBundleSelectionVariant(leadVariant);
      } else if (!hasEngagedCover()) {
        clearBundleSelectionVariant();
      }

      var showReady = !cartUnavailable && items.length > 0;
      var totals = { totalPrice: 0, totalCompare: 0, hasCompare: false };

      if (items.length > 0) {
        refreshIgCoverPrices();
        totals = sumSelectedCoverTotals();
      }
      var showPrompt = items.length === 0 && !previewUnavailable;
      var showKlaviyoBis = klaviyoBisEnable && isUnavailable;
      var showSoldOut = isUnavailable && !klaviyoBisEnable;
      var leadItem = items.length ? items[0] : null;
      var klaviyoVariantId = isUnavailable ? getUnavailableVariantId(items, leadVariant) : null;

      if (atcBtn) {
        atcBtn.classList.remove('kv-scb__btn--prompt', 'kv-scb__btn--sold-out', 'is-disabled');

        if (showPrompt) {
          setAtcIntegrationMode('prompt');
          detachProductFormVariantForPrompt();
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled', 'kv-scb__btn--prompt');
          if (atcLabelEl) atcLabelEl.textContent = atcPromptLabel;
          setAtcStatusText(atcPromptLabel);
          if (atcPricesWrap) atcPricesWrap.hidden = true;
        } else if (showKlaviyoBis && klaviyoVariantId) {
          atcBtn.classList.add('kv-scb__btn--sold-out');
          if (atcPricesWrap) atcPricesWrap.hidden = true;
          setAtcKlaviyoMode(true, klaviyoVariantId);
        } else if (showKlaviyoBis) {
          setAtcIntegrationMode('sold-out');
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled', 'kv-scb__btn--sold-out');
          if (atcLabelEl) atcLabelEl.textContent = atcSoldOutLabel;
          setAtcStatusText(atcSoldOutLabel);
          if (atcPricesWrap) atcPricesWrap.hidden = true;
        } else if (showSoldOut) {
          setAtcIntegrationMode('sold-out');
          atcBtn.disabled = true;
          atcBtn.classList.add('is-disabled', 'kv-scb__btn--sold-out');
          if (atcLabelEl) atcLabelEl.textContent = atcSoldOutLabel;
          setAtcStatusText(atcSoldOutLabel);
          if (atcPricesWrap) atcPricesWrap.hidden = true;
          if (klaviyoVariantId) syncBundleSelectionVariant(findVariantById(klaviyoVariantId));
        } else {
          setAtcIntegrationMode('ready');
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-disabled');
          if (atcLabelEl) atcLabelEl.textContent = atcReadyLabel;
          setAtcStatusText(atcReadyLabel);
          if (atcPricesWrap) atcPricesWrap.hidden = false;
          if (items.length === 1) {
            if (leadItem && leadItem.id) {
              syncBundleSelectionVariant(findVariantById(leadItem.id));
            } else if (leadVariant && leadVariant.id) {
              syncBundleSelectionVariant(leadVariant);
            }
          }
        }
      }

      updateAtcPriceDisplay(totals, showReady);
    }

    function refreshAll() {
      root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
        refreshCoverPrice(cover);
      });
      updateAtcTotals();
    }

    function filterGallery() {
      var checked = root.querySelector('[data-kv-scb-global-color]:checked');
      if (!checked) return;
      var colorHandle = checked.getAttribute('data-color-value-handle');
      if (!colorHandle) return;

      var productEl = root.closest('.js-product');
      if (!productEl) return;

      var slides = productEl.querySelectorAll('.js-swatch-media');
      if (!slides.length) return;

      var matchCount = 0;
      slides.forEach(function (slide) {
        var handle = slide.getAttribute('data-swatch-handle') || '';
        if (handle.indexOf(colorHandle) !== -1) matchCount++;
      });

      var useHandle = matchCount === 0 ? 'default' : colorHandle;
      slides.forEach(function (slide) {
        var swatchHandle = slide.getAttribute('data-swatch-handle') || '';
        var visible = swatchHandle === 'default' || swatchHandle.indexOf(useHandle) !== -1;
        slide.classList.toggle('product-gallery__item--hidden', !visible);
        slide.classList.toggle('js-product-gallery-slide-visible', visible);
      });

      var gallery = productEl.querySelector('.js-product-gallery');
      if (gallery && gallery.o && typeof gallery.o.setupSlideshow === 'function') {
        gallery.o.setupSlideshow();
      }
    }

    function openAjaxCart() {
      var cartBtn = document.getElementById('ajaxCartBtn');
      if (cartBtn) {
        cartBtn.click();
        return;
      }
      var cartDrawer = document.getElementById('ajaxCart');
      var overlay = document.getElementById('aboveHeaderOverlay');
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cartDrawer.classList.add('is-visible');
          if (overlay) overlay.classList.add('is-visible');
        });
      });
      document.body.style.overflow = 'hidden';
    }

    function getShopifySectionKey(element) {
      if (!element) return null;
      var section = element.closest('[id^="shopify-section-"]');
      if (!section || !section.id) return null;
      return section.id.replace('shopify-section-', '');
    }

    function getCartSectionIds() {
      var ids = [];
      var cartKey = getShopifySectionKey(document.getElementById('ajaxCart'));
      var headerKey = getShopifySectionKey(document.getElementById('ajaxCartBtn'));
      if (cartKey) ids.push(cartKey);
      if (headerKey && ids.indexOf(headerKey) === -1) ids.push(headerKey);
      return ids;
    }

    function buildCartPayload(lineItems) {
      return lineItems.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: {
            _ModuleName: item.moduleName,
            _VariantSKU: item.sku,
            _Price: item.priceCents,
            _ComparePrice: item.compareCents,
            _Available: item.available
          }
        };
      });
    }

    async function refreshCartDrawer(cartResponse) {
      if (cartResponse) {
        if (window.EventBus && typeof window.EventBus.emit === 'function') {
          window.EventBus.emit('cart:changed', cartResponse);
          window.EventBus.emit('cart:updated', cartResponse);
        }
        document.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartResponse } })
        );
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: cartResponse })
        );
        return cartResponse;
      }

      var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var baseUrl = cartRoot.replace(/\/?$/, '/');
      var cart = await fetch(baseUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });

      var sectionIds = getCartSectionIds();
      if (sectionIds.length) {
        var sections = await fetch(baseUrl + '?sections=' + sectionIds.join(','), {
          headers: { Accept: 'application/json' }
        }).then(function (r) {
          return r.json();
        });
        cart.sections = sections;
      }

      if (window.EventBus && typeof window.EventBus.emit === 'function') {
        window.EventBus.emit('cart:changed', cart);
        window.EventBus.emit('cart:updated', cart);
      }
      document.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
      );
      return cart;
    }

    async function addToCart() {
      if (atcBtn && atcBtn.classList.contains('klaviyo-bis-trigger')) return;
      if (atcBtn && atcBtn.getAttribute('data-kv-scb-atc-mode') !== 'ready') return;

      var lineItems = collectLineItemsForCart();
      if (!lineItems.length) return;
      if (lineItems.some(function (item) { return !item.available; })) return;

      var payload = buildCartPayload(lineItems);

      setAtcAddingState(true);

      try {
        var cartData = null;

        if (typeof window.addItemsToCart === 'function') {
          cartData = await window.addItemsToCart(payload, false, {});
        } else {
          var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          var baseUrl = cartRoot.replace(/\/?$/, '/');
          var sectionIds = getCartSectionIds();
          var body = { items: payload };

          if (sectionIds.length) {
            body.sections = sectionIds;
          }

          var response = await fetch(baseUrl + 'cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          cartData = await response.json();
          if (!response.ok) {
            throw new Error((cartData && cartData.description) || 'Could not add to cart');
          }
        }

        await refreshCartDrawer(cartData);
        openAjaxCart();
      } catch (err) {
        /* cart errors surface via Shopify / theme cart UI */
      } finally {
        setAtcAddingState(false);
        updateAtcTotals();
      }
    }

    root.querySelectorAll('[data-kv-scb-cover]').forEach(function (cover) {
      setCoverState(cover, 'idle');
      updateModuleColorAvailability(cover);
    });
    updateAtcTotals();

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!root.contains(target)) return;

      if (target.matches('[data-kv-scb-global-color], [data-kv-scb-module-color]')) {
        handleColorSelection(target);
        return;
      }

      if (target.matches('[data-kv-scb-size]')) {
        handleSizeSelection(target);
        return;
      }

      if (target.matches('[data-kv-scb-qty]')) {
        var qtyCover = target.closest('[data-kv-scb-cover]');
        if (qtyCover) updateAtcTotals();
      }
    });

    root.addEventListener('click', function (event) {
      var target = event.target;

      var materialTab = target.closest('[data-kv-scb-material-tab]');
      if (materialTab) {
        event.preventDefault();
        if (materialTab.classList.contains('is-active')) return;
        var nextProductId = materialTab.getAttribute('data-product-id');
        if (nextProductId) switchMaterialProduct(nextProductId);
        return;
      }

      if (target.closest('.kv-scb__size-btn')) {
        var sizeCover = target.closest('[data-kv-scb-cover]');
        var sizeLabel = target.closest('.kv-scb__size-btn');
        var sizeInput = sizeLabel ? document.getElementById(sizeLabel.getAttribute('for')) : null;
        if (sizeInput && !sizeInput.checked) {
          sizeInput.checked = true;
          sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (sizeInput) {
          handleSizeSelection(sizeInput);
        }
        return;
      }

      if (target.closest('[data-kv-scb-add]')) {
        var cover = target.closest('[data-kv-scb-cover]');
        resetCoverToDefaults(cover);
        setCoverState(cover, 'editing');
        updateAtcTotals();
        return;
      }

      if (target.closest('[data-kv-scb-cancel]')) {
        var cancelCover = target.closest('[data-kv-scb-cover]');
        resetCoverToDefaults(cancelCover);
        setCoverState(cancelCover, 'idle');
        refreshAll();
        return;
      }

      if (target.closest('[data-kv-scb-color-more]')) {
        var colorGrid = root.querySelector('[data-kv-scb-color-grid]');
        if (colorGrid) colorGrid.classList.add('kv-scb__color-grid--expanded');
        return;
      }

      if (target.closest('[data-kv-scb-toggle-swatches]')) {
        var swatchCover = target.closest('[data-kv-scb-cover]');
        var swatchesEl = swatchCover.querySelector('[data-kv-scb-module-colors]');
        var isHidden = swatchesEl && swatchesEl.hidden;
        setSwatchesVisible(swatchCover, isHidden);
        return;
      }

      if (target.closest('[data-kv-scb-change]')) {
        var toggleCover = target.closest('[data-kv-scb-cover]');
        var panel = toggleCover.querySelector('[data-kv-scb-panel]');
        var swatchesEl = toggleCover.querySelector('[data-kv-scb-module-colors]');
        var changeCancelBtn = toggleCover.querySelector('[data-kv-scb-cancel]');
        var headerQty = toggleCover.querySelector('[data-kv-scb-header-qty]');
        var changeBtn = toggleCover.querySelector('[data-kv-scb-change]');
        var variantsBlock = toggleCover.querySelector('[data-kv-scb-variants]');

        toggleCover.classList.add('kv-scb__cover--panel-open');
        if (panel) panel.hidden = false;
        if (changeCancelBtn) changeCancelBtn.hidden = false;
        if (headerQty) headerQty.hidden = true;
        if (changeBtn) changeBtn.hidden = true;
        if (variantsBlock) variantsBlock.hidden = true;
        setSwatchesVisible(toggleCover, swatchesEl && swatchesEl.hidden);
        updatePanelColorLabel(toggleCover);
        updateModuleColorAvailability(toggleCover);
        updateAtcTotals();
        return;
      }

      if (target.closest('[data-kv-scb-update]')) {
        var updateCover = target.closest('[data-kv-scb-cover]');
        var selection = getCoverSelection(updateCover);
        var variant = findVariant(selection.moduleName, selection.color, selection.size);

        if (!variant || !isVariantInStock(variant)) {
          return;
        }

        var panelQty = updateCover.querySelector('[data-kv-scb-panel-qty] [data-kv-scb-qty]');
        var headerQty = updateCover.querySelector('[data-kv-scb-header-qty] [data-kv-scb-qty]');
        if (panelQty && headerQty) headerQty.value = panelQty.value;

        setCoverState(updateCover, 'confirmed');
        updateCoverSummary(updateCover);
        updateCover.classList.remove('kv-scb__cover--panel-open');
        setSwatchesVisible(updateCover, false);
        var updateHeaderQty = updateCover.querySelector('[data-kv-scb-header-qty]');
        var updateChangeBtn = updateCover.querySelector('[data-kv-scb-change]');
        if (updateHeaderQty) updateHeaderQty.hidden = false;
        if (updateChangeBtn) updateChangeBtn.hidden = false;
        refreshAll();
        return;
      }

      if (target.closest('.kv-scb__color-item')) {
        var colorItem = target.closest('.kv-scb__color-item');
        var colorInput = colorItem
          ? colorItem.querySelector(
              'input[type="radio"][data-kv-scb-global-color], input[type="radio"][data-kv-scb-module-color]'
            )
          : null;

        if (!colorInput || colorInput.disabled) return;

        if (!colorInput.checked) {
          colorInput.checked = true;
          colorInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        handleColorSelection(colorInput);
      }
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function (event) {
        if (atcBtn.classList.contains('klaviyo-bis-trigger')) return;
        event.preventDefault();
        addToCart();
      });
    }

    bindMarketPriceRefresh();
    initKvScbOfferTimer(root);
    initKvScbStockUrgency(root);
    syncCurrencyFromCart().finally(function () {
      refreshAll();
    });
    updateSelectedSwatches(root);
    captureGalleryConstructor();
    filterGallery();

    var igPollStarted = Date.now();
    var igPoll = setInterval(function () {
      if (window.igData && window.igData.price) {
        clearInterval(igPoll);
        refreshAll();
        return;
      }
      if (Date.now() - igPollStarted > 15000) clearInterval(igPoll);
    }, 100);
  }

  document.querySelectorAll('[data-kv-scb]').forEach(initKvSofaCoverBundle);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-kv-scb]').forEach(initKvSofaCoverBundle);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
